(function () {
      const STORAGE_KEY = 'rm_copy_variant';
      const DEFAULT_VARIANT_ID = 'see_compare_97_control';
      const landingSee = "See Today's Best New Roof Offer In Your ZIP Code";
      const landingUnlock = "Unlock Today's Best New Roof Offer In Your ZIP Code";
      const landingPower = 'Your Roof. One Match. Best Offer.';
      const subMatch =
        'We match you with one vetted local roofer with the best combination of verified reviews, warranty strength, workmanship quality, and current promotions.';
      const subCompare =
        'We compare live promotions, warranty coverage & verified reviews to find the top-scoring roofer for your home.';
      const subRoofmatch =
        'RoofMetric\u2122 scans live promotions, warranty tiers & verified reviews to pick the top-scoring roofer for your home.';
      const subCompareZeroSpam =
        'We compare live promotions, warranty coverage & verified reviews to find the top-scoring roofer for your home - one introduction, zero spam.';
      const quizOffer97 = "See Today's Best Roof Offer (As Low As $97/mo)";
      const quizSeeNeighborhood = "See Today's Best Roof Offer In Your Neighborhood";
      const quizUnlockNeighborhood = "Unlock Today's Best Roof Offer In Your Neighborhood";
      const quizEstimate = 'See My Match & Estimate (As Low As $97/mo)';
      const DEFAULT_VARIANTS = {
        see_compare_97_control: {
          landingHeadline: landingSee,
          landingSubheadline: subCompare,
          quizHeadline: quizOffer97
        },
        unlock_compare_97: {
          landingHeadline: landingUnlock,
          landingSubheadline: subCompare,
          quizHeadline: quizOffer97
        },
        see_match_97: {
          landingHeadline: landingSee,
          landingSubheadline: subMatch,
          quizHeadline: quizOffer97
        },
        see_compare_neighborhood: {
          landingHeadline: landingSee,
          landingSubheadline: subCompare,
          quizHeadline: quizSeeNeighborhood
        },
        unlock_compare_neighborhood: {
          landingHeadline: landingSee,
          landingSubheadline: subCompare,
          quizHeadline: quizUnlockNeighborhood
        },
        see_roofmatch_97: {
          landingHeadline: landingSee,
          landingSubheadline: subRoofmatch,
          quizHeadline: quizOffer97
        },
        see_compare_zeroswam_97: {
          landingHeadline: landingSee,
          landingSubheadline: subCompareZeroSpam,
          quizHeadline: quizOffer97
        },
        see_compare_outcomeCTA_97: {
          landingHeadline: landingSee,
          landingSubheadline: subCompare,
          quizHeadline: quizEstimate
        },
        power_headline_roofmatch_97: {
          landingHeadline: landingPower,
          landingSubheadline: subCompare,
          quizHeadline: quizOffer97
        }
      };

      if (window.__RM_CONFIG__ && window.__RM_CONFIG__.variantId && !window.__RM_VARIANT_ID__) {
        window.__RM_VARIANT_ID__ = window.__RM_CONFIG__.variantId;
      }
      if (window.__RM_CONFIG__ && window.__RM_CONFIG__.flowVariant && !window.__RM_FLOW_VARIANT__) {
        window.__RM_FLOW_VARIANT__ = window.__RM_CONFIG__.flowVariant;
      }

      const variantSubscribers = new Set();
      let currentMap = { ...DEFAULT_VARIANTS };
      let variantMeta = new Map();
      window.__RM_VARIANT_META__ = variantMeta;

      function readStorage() {
        try {
          return window.localStorage.getItem(STORAGE_KEY) || '';
        } catch (_) {
          return '';
        }
      }

      function writeStorage(value) {
        try {
          window.localStorage.setItem(STORAGE_KEY, value);
        } catch (_) {
          /* ignore */
        }
      }

      function getParentVariant(map) {
        try {
          if (window.parent && window.parent !== window) {
            const parentVariant =
              (window.parent.__RM_CURRENT_VARIANT__ && window.parent.__RM_CURRENT_VARIANT__.id) ||
              (window.parent.__RM_CONFIG__ && window.parent.__RM_CONFIG__.copyVariant) ||
              '';
            if (parentVariant && map[parentVariant]) {
              return parentVariant;
            }
          }
        } catch (_) {
          /* ignore cross-origin errors */
        }
        return '';
      }

      function notifySubscribers(id, copy, meta) {
        variantSubscribers.forEach((fn) => {
          try {
            fn(id, copy, meta);
          } catch (_) {
            /* ignore listener errors */
          }
        });
      }

      function setActiveVariant(id) {
        if (!id || !currentMap[id]) return;
        const copy = currentMap[id];
        const meta = variantMeta.get(id) || null;
        const copyKey =
          (typeof meta?.name === 'string' && meta.name.trim()) ||
          (typeof copy?.copy_variant === 'string' && copy.copy_variant.trim()) ||
          id;
        window.__RM_COPY_VARIANTS__ = currentMap;
        window.__RM_VARIANT_ID__ = id;
        window.__RM_CURRENT_VARIANT__ = { id, copy, meta };
        window.__RM_ACTIVE_COPY_VARIANT__ = copyKey;
        window.__RM_CONFIG__ = Object.assign({}, window.__RM_CONFIG__, {
          copyVariant: copyKey,
          copyVariantData: copy
        });
        notifySubscribers(id, copy, meta);
      }

      function selectVariantId(map, weights, options) {
        const ids = Object.keys(map || {});
        if (!ids.length) return '';
        const parent = getParentVariant(map);
        if (parent) return parent;
        const stored = readStorage();
        if (stored && map[stored]) return stored;
        if (Array.isArray(weights) && weights.length) {
          const validWeights = weights.filter((entry) => map[entry.id]);
          const total = validWeights.reduce((sum, entry) => {
            return sum + (entry.weight > 0 ? entry.weight : 0);
          }, 0);
          if (total > 0) {
            let roll = Math.random() * total;
            for (const entry of validWeights) {
              const weight = entry.weight > 0 ? entry.weight : 0;
              roll -= weight;
              if (roll <= 0) return entry.id;
            }
          }
          const defaultEntry = validWeights.find((entry) => entry.isDefault);
          if (defaultEntry) return defaultEntry.id;
        }
        if (options && options.fallback && map[options.fallback]) return options.fallback;
        return ids[0];
      }

      function normalizeCopy(source, fallback) {
        const base = fallback || DEFAULT_VARIANTS[DEFAULT_VARIANT_ID] || {};
        const copyVariantKey =
          (typeof source?.copy_variant === 'string' && source.copy_variant.trim()) ||
          (typeof source?.variant === 'string' && source.variant.trim()) ||
          '';
        const landingHeadline =
          (typeof source?.landingHeadline === 'string' && source.landingHeadline.trim()) ||
          (typeof source?.landing_headline === 'string' && source.landing_headline.trim()) ||
          base.landingHeadline ||
          '';
        const landingSubheadline =
          (typeof source?.landingSubheadline === 'string' && source.landingSubheadline.trim()) ||
          (typeof source?.landing_subheadline === 'string' && source.landing_subheadline.trim()) ||
          base.landingSubheadline ||
          '';
        const quizHeadline =
          (typeof source?.quizHeadline === 'string' && source.quizHeadline.trim()) ||
          (typeof source?.quiz_headline === 'string' && source.quiz_headline.trim()) ||
          base.quizHeadline ||
          '';
        return {
          landingHeadline,
          landingSubheadline,
          quizHeadline,
          copy_variant: copyVariantKey
        };
      }

      function hydrateFromRemote(list) {
        if (!Array.isArray(list) || !list.length) return;
        const nextMap = {};
        const weights = [];
        const nextMeta = new Map();
        list.forEach((item) => {
          if (!item) return;
          const key =
            (typeof item.id === 'string' && item.id.trim()) ||
            (typeof item.slug === 'string' && item.slug.trim()) ||
            (typeof item.key === 'string' && item.key.trim()) ||
            (typeof item.name === 'string' && item.name.trim()) ||
            (typeof item.id === 'number' ? String(item.id) : '');
          if (!key) return;
          const copySource = (item.copy && typeof item.copy === 'object' ? item.copy : null) ||
            (item.settings && typeof item.settings === 'object' ? item.settings : null) ||
            {};
          nextMap[key] = normalizeCopy(copySource, DEFAULT_VARIANTS[DEFAULT_VARIANT_ID]);
          nextMeta.set(key, {
            id: item.id,
            name: typeof item.name === 'string' ? item.name.trim() : null,
            raw: item
          });
          const rawWeight = Number(item.weight);
          weights.push({
            id: key,
            weight: Number.isFinite(rawWeight) && rawWeight > 0 ? rawWeight : 0,
            isDefault: !!item.is_default
          });
        });
        if (!Object.keys(nextMap).length) return;
        currentMap = nextMap;
        variantMeta = nextMeta;
        window.__RM_VARIANT_META__ = variantMeta;
        const presetId =
          (window.__RM_CONFIG__ && typeof window.__RM_CONFIG__.variantId === 'string'
            ? window.__RM_CONFIG__.variantId
            : '') || '';
        if (presetId && currentMap[presetId]) {
          writeStorage(presetId);
          setActiveVariant(presetId);
          return;
        }
        const nextId = selectVariantId(
          currentMap,
          weights,
          { fallback: DEFAULT_VARIANT_ID }
        );
        if (nextId) {
          writeStorage(nextId);
          setActiveVariant(nextId);
        }
      }

      const initialId = selectVariantId(
        currentMap,
        null,
        { fallback: DEFAULT_VARIANT_ID }
      );
      if (initialId) {
        writeStorage(initialId);
        setActiveVariant(initialId);
      }

      window.__RM_HYDRATE_VARIANTS__ = hydrateFromRemote;
      window.__RM_ON_VARIANT__ = function (cb) {
        if (typeof cb !== 'function') return;
        variantSubscribers.add(cb);
        if (window.__RM_CURRENT_VARIANT__) {
          try {
            cb(
              window.__RM_CURRENT_VARIANT__.id,
              window.__RM_CURRENT_VARIANT__.copy,
              window.__RM_CURRENT_VARIANT__.meta || null
            );
          } catch (_) {
            /* noop */
          }
        }
      };
      window.__RM_SET_VARIANT__ = function(id){
        const key = typeof id === 'string' ? id : '';
        if (!key || !currentMap[key]) return;
        writeStorage(key);
        setActiveVariant(key);
      };
    })();
  


    function showFatal(msg){
      try{
        var stg=document.getElementById('stage');
        if(stg){ stg.innerHTML = '<div class="err">'+ String(msg||'Load error') +'</div>'; }
      }catch(_){}
    }
    window.addEventListener('error', function(e){ showFatal(e && e.message ? e.message : 'Script error'); });
    window.addEventListener('unhandledrejection', function(e){ showFatal((e && e.reason && (e.reason.message||e.reason)) || 'Script promise error'); });

    const REQUIRE_CONSENT = false;

    // --- Runtime config (allows host page to override endpoints/keys) ---
    const RM_CONFIG = (() => {
      const fromSelf = (typeof window.__RM_CONFIG__ === 'object' && window.__RM_CONFIG__) || null;
      let fromParent = null;
      if (!fromSelf && window.parent && window.parent !== window) {
        try {
          fromParent = window.parent.__RM_CONFIG__ || null;
        } catch (_) {
          fromParent = null;
        }
      }
      // Inline config bootstrap: prefer JSON from #rm-config script tag
      let fromScript = null;
      const cfgEl = document.getElementById('rm-config');
      if (cfgEl && cfgEl.textContent) {
        try { fromScript = JSON.parse(cfgEl.textContent); } catch (_) { fromScript = null; }
      }
      const defaults = {
        apiBase: '/api/roofmatch',
        supabaseUrl: '',
        supabaseAnonKey: '',
        projectSlug: 'roof-quiz',
        projectId: '',
        quizEntry: null,
        firstQuestion: null,
        finalCtaText: 'Get Results',
        bootstrapReady: false
      };
      return Object.assign({}, defaults, fromScript || {}, fromParent || {}, fromSelf || {});
    })();

    // --- Remote config (Pages Function/Worker) ---
    let API_BASE = RM_CONFIG.apiBase || '/api/roofmatch';
    function getApiBase() {
      return (RM_CONFIG && RM_CONFIG.apiBase) || API_BASE || '/api/roofmatch';
    }
    const shouldFetchRemote =
      !RM_CONFIG?.bootstrapReady ||
      !RM_CONFIG.supabaseAnonKey ||
      RM_CONFIG.supabaseAnonKey === 'YOUR_ANON_KEY' ||
      !RM_CONFIG.apiBase;

    const CONFIG_PROMISE = shouldFetchRemote
      ? (async () => {
      try {
        const res = await fetch('/api/quiz-config', { cache: 'no-store' });
        if (!res.ok) throw new Error('config fetch failed: ' + res.status);
        const remote = await res.json();
        if (remote && typeof remote === 'object') {
          const prevVariants = Array.isArray(RM_CONFIG.copyVariants) ? RM_CONFIG.copyVariants : null;
          const prevVariantId = RM_CONFIG.variantId || null;
          const prevFlowVariant = RM_CONFIG.flowVariant || null;
          const prevCopyVariant = RM_CONFIG.copyVariant || null;
          const prevEntry = RM_CONFIG.quizEntry || null;
          const prevFinalCta = RM_CONFIG.finalCtaText || null;
          Object.assign(RM_CONFIG, remote);
          if (!remote.quizFlow) {
            RM_CONFIG.quizFlow = null;
          }
          if ((!remote.copyVariants || !remote.copyVariants.length) && prevVariants) {
            RM_CONFIG.copyVariants = prevVariants;
          }
          if (!remote.variantId && prevVariantId) {
            RM_CONFIG.variantId = prevVariantId;
          }
          if (!remote.flowVariant && prevFlowVariant) {
            RM_CONFIG.flowVariant = prevFlowVariant;
          }
          if (!remote.copyVariant && prevCopyVariant) {
            RM_CONFIG.copyVariant = prevCopyVariant;
          }
          if (!remote.quizEntry && prevEntry) {
            RM_CONFIG.quizEntry = prevEntry;
          }
          if (!remote.finalCtaText && prevFinalCta) {
            RM_CONFIG.finalCtaText = prevFinalCta;
          }
          RM_CONFIG.bootstrapReady = true;
          window.__RM_CONFIG__ = RM_CONFIG;
          API_BASE = RM_CONFIG.apiBase || API_BASE;
        }
      } catch (err) {
        console.warn('Config fetch failed', err);
      }
      return RM_CONFIG;
    })()
      : Promise.resolve(RM_CONFIG);

    const BOOTSTRAP_PROMISE = CONFIG_PROMISE.then(async (config) => {
      await ensureQuestionsReady();
      return config;
    });

    BOOTSTRAP_PROMISE.then((config) => {
      const variantList = Array.isArray(config?.copyVariants) && config.copyVariants.length
        ? config.copyVariants
        : (Array.isArray(config?.variants) && config.variants.length ? config.variants : null);
      let hydratedVariants = false;
      if (variantList && typeof window.__RM_HYDRATE_VARIANTS__ === 'function') {
        hydratedVariants = true;
        window.__RM_HYDRATE_VARIANTS__(variantList);
      }
      if (!hydratedVariants && config?.quizFlow?.variant?.id && typeof window.__RM_SET_VARIANT__ === 'function') {
        window.__RM_SET_VARIANT__(config.quizFlow.variant.id);
      }
    }).catch(() => {});

    function normalizeOrigin(value) {
      if (typeof value !== 'string') return '';
      const trimmed = value.trim();
      if (!trimmed || trimmed === 'null') return '';
      try {
        return new URL(trimmed, window.location.href).origin;
      } catch (_) {
        return '';
      }
    }

    const PARENT_ORIGIN = (() => {
      const candidates = [
        RM_CONFIG.parentOrigin,
        document.referrer || ''
      ];
      let origin = '';
      for (let i = 0; i < candidates.length && !origin; i++) {
        origin = normalizeOrigin(candidates[i]);
      }
      if (!origin) {
        try {
          if (window.parent && window.parent !== window && window.parent.location) {
            origin = normalizeOrigin(window.parent.location.origin);
          }
        } catch (_) {
          origin = '';
        }
      }
      if (!origin) {
        origin = window.location.origin;
      }
      if (!RM_CONFIG.parentOrigin) {
        RM_CONFIG.parentOrigin = origin;
      }
      return origin;
    })();

    function postToParent(message) {
      if (!message || !window.top || window.top === window) return;
      try {
        window.top.postMessage(message, PARENT_ORIGIN);
      } catch (_) {
        // ignore failures so we never break quiz flow
      }
    }

    // === Supabase Edge Function (roofmatch) ===

    function sbHeaders() {
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      };
      if (RM_CONFIG.supabaseAnonKey) {
        const key = RM_CONFIG.supabaseAnonKey;
        headers['apikey'] = key;
        headers['Authorization'] = 'Bearer ' + key;
      }
      return headers;
    }

    function buildVariantId(flowVariant, copyVariant) {
      const flowKey = flowVariant === 'when_first' ? 'when' : 'need';
      const copyKey = copyVariant || 'see_compare_97_control';
      return [flowKey, copyKey].filter(Boolean).join('_');
    }

    const FLOW_STORAGE_KEY = 'rm_flow_variant';
    const FLOW_VARIANTS = ['need_first', 'when_first'];

    function readFlowVariant() {
      try {
        return window.sessionStorage.getItem(FLOW_STORAGE_KEY) || '';
      } catch (_) {
        return '';
      }
    }

    function writeFlowVariant(value) {
      try {
        window.sessionStorage.setItem(FLOW_STORAGE_KEY, value);
      } catch (_) {
        /* ignore */
      }
    }

    function chooseFlowVariant() {
      const configVariant =
        (window.__RM_CONFIG__ && window.__RM_CONFIG__.flowVariant) ||
        (window.__RM_FLOW_VARIANT__ || '');
      if (configVariant && FLOW_VARIANTS.includes(configVariant)) {
        writeFlowVariant(configVariant);
        return configVariant;
      }
      const stored = readFlowVariant();
      if (stored && FLOW_VARIANTS.includes(stored)) return stored;
      const chosen = Math.random() < 0.5 ? FLOW_VARIANTS[0] : FLOW_VARIANTS[1];
      writeFlowVariant(chosen);
      return chosen;
    }

    const FLOW_VARIANT = chooseFlowVariant();
    window.__RM_FLOW_VARIANT__ = FLOW_VARIANT;
    const ACTIVE_COPY_VARIANT =
      window.__RM_ACTIVE_COPY_VARIANT__ ||
      (window.__RM_CURRENT_VARIANT__ && window.__RM_CURRENT_VARIANT__.id) ||
      (window.__RM_CONFIG__ && window.__RM_CONFIG__.copyVariant) ||
      'see_compare_97_control';
    const COMBINED_VARIANT_ID = buildVariantId(FLOW_VARIANT, ACTIVE_COPY_VARIANT);
    window.__RM_VARIANT_COMBO__ = COMBINED_VARIANT_ID;
    if (!window.__RM_VARIANT_ID__) {
      window.__RM_VARIANT_ID__ =
        (window.__RM_CURRENT_VARIANT__ && window.__RM_CURRENT_VARIANT__.id) ||
        COMBINED_VARIANT_ID;
    }
    window.__RM_CONFIG__ = Object.assign({}, window.__RM_CONFIG__ || {}, {
      flowVariant: FLOW_VARIANT,
      variantId: COMBINED_VARIANT_ID
    });

    const FINAL_CTA_TEXT = (typeof RM_CONFIG.finalCtaText === 'string' && RM_CONFIG.finalCtaText.trim())
      ? RM_CONFIG.finalCtaText.trim()
      : 'Get Results';

    const DEFAULT_FLOW_SEQUENCE = ['need', 'when', 'pay', 'zip', 'address', 'name', 'contact'];
    let QUESTIONS = [];
    let FULL_FLOW_PROMISE = null;
    const INITIAL_FLOW_PAYLOAD = (RM_CONFIG?.quizFlow && RM_CONFIG.quizFlow.questions)
      ? RM_CONFIG.quizFlow
      : null;
    const INITIAL_FIRST_QUESTION = !INITIAL_FLOW_PAYLOAD && RM_CONFIG?.firstQuestion
      ? normalizeQuestionPayload(RM_CONFIG.firstQuestion, 0)
      : null;
    let activeVariantId =
      (window.__RM_CONFIG__ && window.__RM_CONFIG__.variantId) ||
      window.__RM_VARIANT_ID__ ||
      null;
    const AUTO_ADVANCE_IDS = new Set(['need', 'when', 'pay']);
    const CENTER_NAV_IDS = new Set(['zip', 'name', 'contact']);
    const DEFAULT_STRINGS = {
      zipPlaceholder: 'ZIP (e.g., 07733)',
      addressPlaceholder: 'Start typing your home address…',
      manualHint: "Can't find your address? Type it manually and tap Next. We only use this to confirm your service area.",
      manualError: "If you don't see your address, try entering it manually. We only use this to confirm your service area.",
      fallbackWarning: 'Address suggestions are unavailable right now. Please enter your full address manually.'
    };
    const DEFAULT_HERO_COPY = {
      brand: 'RoofMetric',
      pill: 'Vetted • Licensed • Insured',
      eyebrow: 'Exclusive 1-to-1 match',
      headline_template: "You're matched with {{company}}",
      subhead: "Thanks for submitting your request. We reserved the roofer below exclusively for you. Confirm an inspection time to lock in today’s promos and priority status."
    };
    const DEFAULT_PROMO_COPY = {
      eyebrow: 'Limited-time perks',
      headline: 'Claim your bonuses',
      note: 'Reserved exclusively for you for the next few minutes — pick a time below to lock everything in.',
      timer_seconds: 420
    };
    const DEFAULT_CALL_COPY = {
      eyebrow: 'Talk it through',
      headline_template: 'Call {{company}} directly',
      note: 'Tap below to reach their project specialist now.',
      button_label: 'Call {{phone_pretty}}'
    };
    const DEFAULT_CALENDAR_COPY = {
      headline: 'Choose your inspection time',
      subhead: 'Secure a slot in the next few minutes to keep today’s bonuses.'
    };
    const DEFAULT_BOOKING_COPY = {
      pill: 'Booked',
      headline_template: 'You’re booked for {{appointment_label}}.',
      subhead_template: 'Thanks, {{company}} will reach out to you ASAP with final confirmation and your crew lead’s name.',
      cta_google: 'Add to Google Calendar',
      cta_apple: 'Add to Apple Calendar',
      cta_partner: 'Go To {{company}}',
      checklist_headline: 'Prep Checklist',
      checklist_subhead: 'Help us give you a faster, tighter quote (2 min):',
      completion_message: 'Thanks—this moves you to priority.'
    };
    const DEFAULT_TY_COPY = {
      pill: 'We’re on it',
      headline: 'We’re finding the best roofer for your project.',
      subhead: 'You’ll hear from a single local pro shortly.'
    };
    function formatTemplate(template, tokens){
      if (!template) return '';
      const dict = tokens || {};
      return String(template).replace(/{{\s*([^}]+)\s*}}/g, function(_, rawKey){
        const key = String(rawKey || '').trim();
        if (!key) return '';
        if (dict[key] != null) return String(dict[key]);
        const lower = key.toLowerCase();
        return dict[lower] != null ? String(dict[lower]) : '';
      });
    }
    function resolveHeroCopy(provider){
      const raw = provider && typeof provider.hero_copy === 'object' ? provider.hero_copy : null;
      return Object.assign({}, DEFAULT_HERO_COPY, raw || {});
    }
    function resolvePromoCopy(provider){
      const raw = provider && typeof provider.promo_copy === 'object' ? provider.promo_copy : null;
      return Object.assign({}, DEFAULT_PROMO_COPY, raw || {});
    }
    function resolveCallCopy(provider){
      const raw = provider && typeof provider.call_copy === 'object' ? provider.call_copy : null;
      return Object.assign({}, DEFAULT_CALL_COPY, raw || {});
    }
    function resolveCalendarCopy(provider){
      const raw = provider && typeof provider.calendar_copy === 'object' ? provider.calendar_copy : null;
      return Object.assign({}, DEFAULT_CALENDAR_COPY, raw || {});
    }
    function resolveBookingCopy(provider){
      const raw = provider && typeof provider.booking_copy === 'object' ? provider.booking_copy : null;
      return Object.assign({}, DEFAULT_BOOKING_COPY, raw || {});
    }
    function resolveTyCopy(copy){
      const raw = copy && typeof copy === 'object' ? copy : null;
      return Object.assign({}, DEFAULT_TY_COPY, raw || {});
    }
    function formatCountdown(seconds){
      const total = Number(seconds);
      if (!Number.isFinite(total) || total <= 0) return '';
      const m = Math.floor(total / 60);
      const s = String(total % 60).padStart(2, '0');
      return m + ':' + s;
    }

    function mapQuestionType(dbType){
      const normalized = String(dbType || '').toLowerCase();
      switch(normalized){
        case 'single_choice':
        case 'single':
          return 'single';
        case 'multi_choice':
        case 'multi':
          return 'multi';
        case 'transition':
          return 'transition';
        case 'loading':
          return 'loading';
        default:
          return normalized || 'text';
      }
    }

    function normalizeQuestionPayload(question, index){
      const analyticsKey = question?.analytics_key || question?.id || DEFAULT_FLOW_SEQUENCE[index] || `step_${index}`;
      const actualQuestionId = question?.question_id || question?.id || analyticsKey;
      const sourcePosition = typeof question?.position === 'number' ? question.position : index;
      const opts = Array.isArray(question?.answers)
        ? question.answers.map((ans, idx) => ({
            value: ans?.value ?? String(idx),
            title: ans?.label || ans?.value || '',
            note: ans?.meta?.note || '',
            raw: ans
          }))
        : [];
      const normalized = {
        id: analyticsKey,
        type: mapQuestionType(question?.question_type),
        label: question?.prompt || '',
        sub: question?.help_text || '',
        placeholder: question?.placeholder || '',
        options: opts,
        answers: opts,
        required: question?.is_required !== false,
        analytics_key: analyticsKey,
        question_id: actualQuestionId,
        source_position: sourcePosition,
        raw: question
      };
      if (!normalized.placeholder) {
        if (analyticsKey === 'zip') normalized.placeholder = 'ZIP (e.g., 07733)';
      }
      return normalized;
    }

    function getQuestionSettings(question){
      if (!question) return {};
      const raw = (question.raw && typeof question.raw === 'object') ? question.raw : question;
      const settings = raw && typeof raw.settings === 'object' && raw.settings !== null ? raw.settings : null;
      return settings || {};
    }

    function getSettingString(settings, key, fallback){
      if (settings && typeof settings[key] === 'string') {
        const trimmed = settings[key].trim();
        if (trimmed) return trimmed;
      }
      return typeof fallback === 'string' ? fallback : '';
    }

    function primeFullFlowFetch(){
      if (RM_CONFIG?.quizFlow && RM_CONFIG.quizFlow.questions) return;
      if (FULL_FLOW_PROMISE || !activeVariantId) return;
      FULL_FLOW_PROMISE = fetchQuizFlowForVariant(activeVariantId)
        .catch((err) => {
          console.warn('full flow fetch failed', err);
        })
        .finally(() => {
          FULL_FLOW_PROMISE = null;
        });
    }

    function fetchQuizFlowForVariant(variantId){
      const search = new URLSearchParams();
      if (variantId) search.set('variant_id', variantId);
      if (RM_CONFIG.projectId) search.set('project_id', RM_CONFIG.projectId);
      const qs = search.toString();
      return fetch(`/api/quiz-flow${qs ? `?${qs}` : ''}`, {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      })
        .then(async res => {
          if (!res.ok) {
            const text = await res.text();
            throw new Error(`quiz-flow failed: ${res.status} ${text}`);
          }
          return res.json();
        })
        .then(data => {
          const flowPayload = {
            variant: data?.variant || null,
            questions: Array.isArray(data?.questions) ? data.questions : [],
            entry: null
          };
          hydrateFromQuizFlow(flowPayload);
          return QUESTIONS;
        });
    }

    function ensureQuestionsReady(){
      if (Array.isArray(QUESTIONS) && QUESTIONS.length) {
        if (QUESTIONS.length === 1 && RM_CONFIG.firstQuestion) {
          primeFullFlowFetch();
        }
        return Promise.resolve(QUESTIONS);
      }
      if (RM_CONFIG?.quizFlow && RM_CONFIG.quizFlow.variant && RM_CONFIG.quizFlow.questions) {
        hydrateFromQuizFlow(RM_CONFIG.quizFlow);
        return Promise.resolve(QUESTIONS);
      }
      return fetchQuizFlowForVariant(activeVariantId);
    }

    function hydrateFromQuizFlow(flowPayload){
      const list = Array.isArray(flowPayload?.questions) ? flowPayload.questions : [];
      QUESTIONS = list.map((q, idx) => normalizeQuestionPayload(q, idx));
      RM_CONFIG.firstQuestion = null;
      RM_CONFIG.quizFlow = flowPayload;
      if (flowPayload?.variant?.settings?.flow_variant) {
        state.flow_variant = flowPayload.variant.settings.flow_variant;
      }
      if (flowPayload?.variant?.name) {
        state.copy_variant = flowPayload.variant.name;
        RM_CONFIG.copyVariant = flowPayload.variant.name;
        state.variant_combo = buildVariantId(state.flow_variant, state.copy_variant);
        window.__RM_VARIANT_COMBO__ = state.variant_combo;
      }
      if (flowPayload?.variant?.id) {
        state.variant_id = flowPayload.variant.id;
        activeVariantId = flowPayload.variant.id;
        window.__RM_VARIANT_ID__ = flowPayload.variant.id;
      }
      if (flowPayload?.variant?.project_id) {
        state.project_id = flowPayload.variant.project_id;
      }
      const entry = flowPayload?.entry && flowPayload.entry.question_id
        ? flowPayload.entry
        : QUESTIONS.length
        ? {
            question_id: QUESTIONS[0].question_id || QUESTIONS[0].id,
            position: typeof QUESTIONS[0].source_position === 'number' ? QUESTIONS[0].source_position : 0
          }
        : null;
      RM_CONFIG.quizEntry = entry;
      state.step = 0;
      state.current_question_id = entry?.question_id || null;
      state.current_position = typeof entry?.position === 'number' ? entry.position : 0;
      state._stepStartMs = Date.now();
    }

    const looksLikeUuid = (value) => typeof value === 'string' && value.includes('-');

    if (typeof window.__RM_ON_VARIANT__ === 'function') {
      window.__RM_ON_VARIANT__(function(id){
        if (!looksLikeUuid(id)) {
          return;
        }
        const canonicalId = (RM_CONFIG?.variantId && looksLikeUuid(RM_CONFIG.variantId))
          ? RM_CONFIG.variantId
          : (window.__RM_VARIANT_ID__ && looksLikeUuid(window.__RM_VARIANT_ID__)
              ? window.__RM_VARIANT_ID__
              : null);
        if (canonicalId && id !== canonicalId) {
          return;
        }
        activeVariantId = id || null;
        if (RM_CONFIG?.quizFlow && RM_CONFIG.quizFlow.variant?.id === id && RM_CONFIG.quizFlow.questions) {
          hydrateFromQuizFlow(RM_CONFIG.quizFlow);
          render();
          return;
        }
        fetchQuizFlowForVariant(activeVariantId)
          .then(() => {
            render();
          })
          .catch(() => {});
      });
    }

    const PREP_ITEMS = [
      'Gate/driveway access available',
      'Pets secured',
      'Best entry point to roof',
      'HOA/permit requirements (if any)'
    ];
    function buildTemplateTokens(provider, extra){
      const tokens = {
        company: (provider && provider.company) || 'your roofer',
        phone: (provider && provider.phone) || '',
        phone_pretty: (provider && provider.phone) ? prettyPhone(String(provider.phone)) : '',
        city:
          (provider && provider.city) ||
          (state.answers.address && state.answers.address.city) ||
          state.cityGuess ||
          '',
        state:
          (provider && (provider.state || provider.state_code)) ||
          (state.answers.address && state.answers.address.state) ||
          state.stateGuess ||
          '',
        service_area: describeServiceArea(provider) || ''
      };
      if (extra && typeof extra === 'object') {
        Object.keys(extra).forEach(function(key){
          tokens[key] = extra[key];
        });
      }
      return tokens;
    }

    /* --- UTM grabber --- */
    function grabUtms() {
      const params = new URLSearchParams(window.location.search);
      return {
        utm_source: params.get("utm_source") || "",
        utm_medium: params.get("utm_medium") || "",
        utm_campaign: params.get("utm_campaign") || "",
        utm_term: params.get("utm_term") || "",
        utm_content: params.get("utm_content") || "",
        gclid: params.get("gclid") || "",
        fbclid: params.get("fbclid") || ""
      };
    }

    const state = {
      step:0,
      answers:{ zip:"", address:{ full:"", street_number:"", route:"", city:"", state:"", zip:"" }, name_first:"", name_last:"", email:"", phone:"" },
      startedAt: Date.now(),
      _stepStartMs: Date.now(),
      utms: grabUtms(),
      ref: document.referrer || "",
      honeypot:"",
      pendingFocusId: null,
      is_homeowner: true,
      cityGuess: "", stateGuess: "",
      _zipMetaPromise: null,
      lead_id: null,
      partner_id: "",
      tcpa_text: "",
      trustedform_url: "",
      trustedform_override: false,
      project_id: RM_CONFIG.projectId || null,
      current_question_id: null,
      current_position: 0,
      address_manual_allowed: false,
      _pendingSubmit: false,
      _submitInflight: false,
      copy_variant:
        (window.__RM_CURRENT_VARIANT__ &&
          ((window.__RM_CURRENT_VARIANT__.meta &&
            typeof window.__RM_CURRENT_VARIANT__.meta.name === 'string' &&
            window.__RM_CURRENT_VARIANT__.meta.name.trim()) ||
            window.__RM_ACTIVE_COPY_VARIANT__ ||
            window.__RM_CURRENT_VARIANT__.id)) ||
        (window.__RM_CONFIG__ && window.__RM_CONFIG__.copyVariant) ||
        '',
      flow_variant: FLOW_VARIANT,
      variant_id:
        (window.__RM_CURRENT_VARIANT__ && window.__RM_CURRENT_VARIANT__.id) ||
        window.__RM_VARIANT_ID__ ||
        null
    };

    if (RM_CONFIG?.flowVariant) {
      state.flow_variant = RM_CONFIG.flowVariant;
    }
    if (RM_CONFIG?.projectId) {
      state.project_id = RM_CONFIG.projectId;
    }
    if (RM_CONFIG?.variantId) {
      state.variant_id = RM_CONFIG.variantId;
      window.__RM_VARIANT_ID__ = RM_CONFIG.variantId;
    }
    if (RM_CONFIG?.copyVariant) {
      state.copy_variant = RM_CONFIG.copyVariant;
    }
    if (RM_CONFIG?.quizEntry && RM_CONFIG.quizEntry.question_id) {
      state.current_question_id = RM_CONFIG.quizEntry.question_id;
      if (typeof RM_CONFIG.quizEntry.position === 'number') {
        state.current_position = RM_CONFIG.quizEntry.position;
      }
    }

    state.copy_variant =
      state.copy_variant ||
      ((window.__RM_CURRENT_VARIANT__ &&
        ((window.__RM_CURRENT_VARIANT__.meta &&
          typeof window.__RM_CURRENT_VARIANT__.meta.name === 'string' &&
          window.__RM_CURRENT_VARIANT__.meta.name.trim()) ||
          window.__RM_ACTIVE_COPY_VARIANT__ ||
          window.__RM_CURRENT_VARIANT__.id)) ||
        (window.__RM_CONFIG__ && window.__RM_CONFIG__.copyVariant) ||
        '');

    if (INITIAL_FLOW_PAYLOAD) {
      hydrateFromQuizFlow(INITIAL_FLOW_PAYLOAD);
    } else if (INITIAL_FIRST_QUESTION) {
      QUESTIONS = [INITIAL_FIRST_QUESTION];
      primeFullFlowFetch();
    }

    if (!state.current_question_id && QUESTIONS.length) {
      const seedQ = QUESTIONS[0];
      state.current_question_id = seedQ.question_id || seedQ.id;
      state.current_position = typeof seedQ.source_position === 'number' ? seedQ.source_position : 0;
    }
    state.variant_id =
      state.variant_id ||
      window.__RM_VARIANT_ID__ ||
      null;
    state.variant_combo = buildVariantId(state.flow_variant, state.copy_variant);

    if (typeof window.__RM_ON_VARIANT__ === 'function') {
      window.__RM_ON_VARIANT__(function(id, copy, meta) {
        const nextId = typeof id === 'string' ? id : '';
        const variantName =
          (typeof meta?.name === 'string' && meta.name.trim()) ||
          (copy && typeof copy.copy_variant === 'string' && copy.copy_variant.trim()) ||
          nextId;
        state.copy_variant = variantName;
        const combined = buildVariantId(state.flow_variant, variantName);
        state.variant_combo = combined;
        if (nextId) {
          state.variant_id = nextId;
          window.__RM_VARIANT_ID__ = nextId;
        }
        window.__RM_VARIANT_COMBO__ = combined;
        window.__RM_CONFIG__ = Object.assign({}, window.__RM_CONFIG__ || {}, {
          copyVariant: variantName,
          copyVariantData: copy || window.__RM_CURRENT_VARIANT__?.copy || null
        });
      });
    }

    function setTrustedFormField(id, value) {
      var el = document.getElementById(id);
      if (el) el.value = value == null ? '' : String(value);
    }

    function updateTrustedFormExtras(){
      setTrustedFormField('tfNeed', state.answers.need || '');
      setTrustedFormField('tfWhen', state.answers.when || '');
      setTrustedFormField('tfPay', state.answers.pay || '');
      setTrustedFormField('tfPartner', state.partner_id || '');
    }

    const NON_INTERACTIVE_TYPES = new Set(['transition', 'loading']);

    function navModeForQuestion(q){
      if (!q || !q.id) return 'default';
      if (NON_INTERACTIVE_TYPES.has(q.type)) return 'none';
      if (AUTO_ADVANCE_IDS.has(q.id)) return 'none';
      if (CENTER_NAV_IDS.has(q.id)) return 'center';
      return 'default';
    }

    function findPreviousInteractiveIndex(fromIndex){
      let idx = typeof fromIndex === 'number' ? fromIndex - 1 : -1;
      while (idx >= 0) {
        const candidate = QUESTIONS[idx];
        if (!candidate) {
          idx--;
          continue;
        }
        if (NON_INTERACTIVE_TYPES.has(candidate.type)) {
          idx--;
          continue;
        }
        return idx;
      }
      return -1;
    }

    function trackTrustedFormValue(){
      const tf = document.getElementById('xxTrustedFormCertUrl');
      if (!tf || tf._tfPollAttached) return;
      tf._tfPollAttached = true;
      let last = '';
      const syncValue = () => {
        const current = tf.value || '';
        if (current && current !== last) {
          last = current;
          state.trustedform_url = current;
          state.trustedform_override = false;
          postEvent('trustedform_cert_captured', { length: current.length });
        }
      };
      const observer = new MutationObserver(syncValue);
      observer.observe(tf, { attributes: true, attributeFilter: ['value'] });
      setInterval(syncValue, 600);
      tf.addEventListener('change', syncValue);
      tf.addEventListener('input', syncValue);
      syncValue();
    }

    // --- Drop-off tracker (no PII) ---
    function readCookie(name){
      try {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : '';
      } catch(_) {
        return '';
      }
    }

    function rmSessionId(){
      const cookieName = 'rm_session_id';
      try {
        const k='rm_sid';
        const cookieSid = readCookie(cookieName);
        let v = localStorage.getItem(k);
        if (cookieSid && cookieSid !== v) {
          v = cookieSid;
          localStorage.setItem(k, v);
        }
        if (!v) {
          v = Math.random().toString(36).slice(2) + Date.now().toString(36).slice(4);
          localStorage.setItem(k, v);
          document.cookie = `${cookieName}=${encodeURIComponent(v)}; path=/; max-age=31536000; samesite=none; secure`;
        } else if (!cookieSid) {
          document.cookie = `${cookieName}=${encodeURIComponent(v)}; path=/; max-age=31536000; samesite=none; secure`;
        }
        return v;
      } catch(_) {
        return String(Date.now());
      }
    }

    const _pendingEvents = [];
    let _configReady = false;

    BOOTSTRAP_PROMISE.then(() => {
      _configReady = true;
      while (_pendingEvents.length) {
        const { action, params } = _pendingEvents.shift();
        dispatchEventPayload(action, params);
      }
    }).catch(() => {
      _configReady = true;
      _pendingEvents.length = 0;
    });

    function dispatchEventPayload(action, params){
      try{
        const q = QUESTIONS[state.step] || {};
        const payload = {
          action,
          ts: new Date().toISOString(),
          session_id: rmSessionId(),
          lead_id: state.lead_id || null,
          step: state.step,
          step_id: q.id || '',
          question_id: q.question_id || state.current_question_id || null,
          label: formatLabel(q.label) || '',
          duration_ms: Date.now() - state.startedAt,
          zip: (state.answers && (state.answers.address.zip || state.answers.zip)) || '',
          utm: state.utms,
          referrer: state.ref,
          device: (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || '',
          page_url: location.href,
          copy_variant: state.copy_variant || null,
          flow_variant: state.flow_variant || null,
          variant_id: state.variant_id || window.__RM_VARIANT_ID__ || null,
          project_id: state.project_id || RM_CONFIG.projectId || null,
          extra: params || {}
        };

        const body = new URLSearchParams({
          endpoint: 'event',
          payload: JSON.stringify(payload)
        });

        return fetch(getApiBase(), {
          method: 'POST',
          headers: sbHeaders(),
          body,
          keepalive: true
        });
      }catch(_){
        return Promise.resolve();
      }
    }

    function postEvent(action, params){
      if (!_configReady || !RM_CONFIG.projectId) {
        _pendingEvents.push({ action, params });
        return;
      }
      dispatchEventPayload(action, params).catch(()=>{});
    }

    const stage = document.getElementById("stage");
    let _lastStepView = -1;
    const bar   = document.getElementById("bar");
    let _firstStepNotified = false;
    let manualHintTimer = null;
    let lastManualHintEl = null;

    function skeletonMarkup(){
      return (
        '<div class="loading loading-skeleton">'
        + '<div class="loading-pill"></div>'
        + '<div class="loading-line loading-line-wide"></div>'
        + '<div class="loading-line loading-line-mid"></div>'
        + '<div class="loading-line loading-line-short"></div>'
        + '</div>'
      );
    }

    function notifyFirstStepReady(){
      if (_firstStepNotified) return;
      _firstStepNotified = true;
      try {
        if (window.parent && window.parent !== window) {
          const origin = PARENT_ORIGIN || '*';
          window.parent.postMessage({ type: 'RM_FIRST_STEP_READY' }, origin);
        }
      } catch (_) {
        /* noop */
      }
    }

    function showLoadingSkeleton(){
      if (!stage) return;
      stage.setAttribute('data-loading', 'true');
      stage.setAttribute('aria-busy', 'true');
      stage.innerHTML = skeletonMarkup();
    }

    function clearManualHintTimer(){
      if (manualHintTimer) {
        clearTimeout(manualHintTimer);
        manualHintTimer = null;
      }
    }

    function showManualHintUI(){
      if (lastManualHintEl) {
        lastManualHintEl.classList.remove('hidden');
      }
    }

    function requestManualHintDisplay(){
      if (!state.address_manual_allowed) {
        state.address_manual_allowed = true;
      }
      showManualHintUI();
    }

    function scheduleManualHintDisplay(cb){
      if (state.address_manual_allowed || manualHintTimer) return;
      manualHintTimer = setTimeout(function(){
        manualHintTimer = null;
        cb();
      }, 10000);
    }

    function hideLoadingSkeleton(){
      if (!stage) return;
      stage.removeAttribute('data-loading');
      stage.removeAttribute('aria-busy');
      stage.innerHTML = '';
    }

    if (stage && stage.dataset.prerender === 'true') {
      stage.removeAttribute('data-loading');
      stage.setAttribute('aria-busy', 'false');
    } else {
      showLoadingSkeleton();
    }

    function setNextLoading(isLoading){
      const btn = document.getElementById('nextBtn');
      if (!btn) return;
      if (isLoading) {
        if (!btn.dataset.loadingLabel) {
          btn.dataset.loadingLabel = btn.textContent || '';
        }
        btn.disabled = true;
        btn.textContent = 'Loading…';
      } else {
        if (btn.dataset.loadingLabel) {
          btn.textContent = btn.dataset.loadingLabel;
          delete btn.dataset.loadingLabel;
        }
      }
    }

    function queue(fn){ setTimeout(fn,0); }
    function updateFootnoteVisibility(){
      const footnote = document.getElementById('footnote');
      if (!footnote) return;
      const current = QUESTIONS[state.step] || {};
      footnote.style.display = current.id === 'contact' ? '' : 'none';
    }

    function render(){
      try{
        if (!stage) return;
        if (stage.dataset.loading === 'true') return;
        const q = QUESTIONS[state.step];
        if(!q){
          return;
        }
        const qSettings = getQuestionSettings(q);

        if (q.id !== 'address') {
          clearManualHintTimer();
          lastManualHintEl = null;
        }

        const actualQuestionId =
          (q.raw && (q.raw.question_id || q.raw.id)) ||
          q.question_id ||
          q.id;
        const actualPosition =
          (q.raw && typeof q.raw.position === 'number' && q.raw.position) ||
          (typeof q.source_position === 'number' ? q.source_position : state.step);
        state.current_question_id = actualQuestionId || null;
        state.current_position = typeof actualPosition === 'number' ? actualPosition : state.step;

        const pct = Math.round(((state.step + 1) / QUESTIONS.length) * 100);
        bar.style.visibility = (state.step === 0) ? "hidden" : "visible";
        bar.style.width = pct + "%";

        if (q.type === 'transition') {
          renderTransitionStep(q);
          return;
        }
        if (q.type === 'loading') {
          renderLoadingStep(q);
          return;
        }

        stage.innerHTML = "";
        const container = document.createElement("div");
        container.className = "fade-enter";
        requestAnimationFrame(function(){ container.classList.add("fade-enter-active"); });

        const title   = el("h1","", formatLabel(q.label));
        const eyebrow = el("div","eyebrow","Step " + (state.step+1) + " of " + QUESTIONS.length);
        if (state.step === 0) {
          eyebrow.classList.add('eyebrow-placeholder');
          eyebrow.setAttribute('aria-hidden','true');
        }
        container.append(eyebrow);
        container.append(title);

        if (q.sub) container.append(el("div","sub", formatLabel(q.sub)));

        let field;
        if(q.type==="single") field = renderSingle(q);
        else if(q.type==="multi") field = renderMulti(q);
        else if(q.type==="text") field = renderZip(q);
        else if(q.type==="address") field = renderAddress(q);
        else if(q.type==="name") field = renderName(q);
        else if(q.type==="contact") field = renderContact(q);
        container.append(field);

        const err = el("div","err hidden",""); 
        err.id = "err"; 
        err.setAttribute('role','alert'); 
        err.setAttribute('aria-live','assertive');
        container.append(err);

        const navMode = navModeForQuestion(q);
        const showNextFlag = typeof qSettings.show_next === 'boolean' ? qSettings.show_next : null;
        const showBackFlag = typeof qSettings.show_back === 'boolean' ? qSettings.show_back : null;
        const navModeForRendering =
          navMode === 'none' && ((showNextFlag ?? false) || (showBackFlag ?? false)) ? 'default' : navMode;
        const showNext = showNextFlag !== null ? showNextFlag : navModeForRendering !== 'none';
        const showBack =
          showBackFlag !== null ? showBackFlag : (navModeForRendering === 'default' && state.step > 0);

        if (showBack || showNext) {
          const navClasses = ["nav"];
          if (state.step === 0) navClasses.push("single");
          if (navModeForRendering === 'center') navClasses.push("centered");
          if (q.id === 'address') navClasses.push('address-layout');
          const nav = el("div", navClasses.join(" "), "");

          if (showBack) {
            const backLabel = getSettingString(qSettings, 'back_label', 'Back') || 'Back';
            const back = button(backLabel, "secondary", onBack);
            nav.append(back);
          }

          if (showNext) {
            const isFinalStep = state.step === QUESTIONS.length - 1;
            const nextLabelFromSettings = getSettingString(qSettings, 'next_label', '');
            const nextLabel =
              nextLabelFromSettings ||
              (isFinalStep ? FINAL_CTA_TEXT : q.id === "zip" ? "Check Availability" : "Next");
            const next = button(nextLabel, "", onNext);
            next.id = "nextBtn";
            if (isFinalStep) {
              next.setAttribute('data-tf-element-role','submit');
              next.type = 'submit';
            } else {
              next.type = 'button';
            }

            if (navModeForRendering === 'center') next.classList.add('btn-wide');
            if (navModeForRendering === 'default' && q.id === 'address') next.classList.add('btn-address');

            nav.append(next);
          }

          container.append(nav);
        }

        // Micro-copy
        if(q.id==="name"){
          const hintBig = el("div","hint-big","Your matches are almost ready!");
          container.append(hintBig);
        }
        
        stage.append(container);
        updateFootnoteVisibility();

        if (state.step === 0) {
          notifyFirstStepReady();
        }

        if (state.pendingFocusId) {
          const elToFocus = stage.querySelector('[data-focus-id="' + state.pendingFocusId + '"]');
          if (elToFocus) safeFocus(elToFocus);    // quiet focus; no scroll
          state.pendingFocusId = null;
        }
        // Pin the question after layout settles
        setTimeout(pinQuestionTop, 60);
        postHeightSoon();
      }catch(e){ showFatal(e.message||e); }
    }

    function renderZip(q){
      const settings = getQuestionSettings(q);
      preloadZipCityMap();
      const wrap = el("div","");
      const input = el("input","");
      input.type = "text";
      const placeholder =
        (typeof q.placeholder === 'string' && q.placeholder.trim()) ||
        getSettingString(settings, 'placeholder', DEFAULT_STRINGS.zipPlaceholder) ||
        DEFAULT_STRINGS.zipPlaceholder;
      input.placeholder = placeholder;
      input.inputMode = "numeric";
      input.autocomplete = "postal-code";
      input.maxLength = 10;
      input.dataset.focusId = "zip";
      input.autofocus = true;
      input.value = state.answers.zip || "";
      const hint = el("div","hint","");
      let lastZipPrefetched = "";
      function prefetchZipMetaFast(z5){
        if (!/^\d{5}$/.test(z5) || lastZipPrefetched === z5) return;
        lastZipPrefetched = z5;
        state._zipMetaPromise = getZipMetadata(z5);
        state._zipMetaPromise.then(function(meta){
          if (!meta) return;
          if (meta.city) state.cityGuess = meta.city;
          if (meta.state) state.stateGuess = meta.state;
          updateAreaLabel();
        }).catch(()=>{});
      }
      wrap.append(input, hint);

      input.addEventListener("input", function(){
        const digits = input.value.replace(/\D/g,"").slice(0,9);
        input.value = digits.length>5 ? (digits.slice(0,5) + "-" + digits.slice(5)) : digits;
        state.answers.zip = input.value;
        const z5 = digits.slice(0,5);
        const btn = document.getElementById("nextBtn");
        if (z5.length===5) {
          state.answers.address.zip = z5;
          prefetchZipMetaFast(z5);
          if (btn) btn.disabled = false;
        } else {
          if (btn) btn.disabled = true;
        }
        hint.textContent = ""; // no hint; fastest path
      });

      // Enter => Next
      input.addEventListener("keydown", function(e){
        if(e.key === "Enter"){ e.preventDefault(); onNext(); }
      });

      queue(function(){ const btn=document.getElementById("nextBtn"); if(btn) btn.disabled = !/^\d{5}(-\d{4})?$/.test((input.value||"").trim()); });
      const existingZip = (state.answers.zip || "").replace(/\D/g,"").slice(0,5);
      if (/^\d{5}$/.test(existingZip)) {
        state.answers.address.zip = existingZip;
        prefetchZipMetaFast(existingZip);
      }

      return wrap;
    }

    function renderSingle(q){
      const grid = el("div","grid");
      grid.setAttribute('role','group');
      grid.setAttribute('aria-label', q.label);
      const current = state.answers[q.id] || null;
      q.options.forEach(function(opt){
        const card = el("button","choice"); card.type="button";
        const left = el("div",""); left.append(el("div","title",opt.title));
        card.append(left, el("div","", "✓"));
        if(current===opt.value) card.classList.add("selected");
        card.setAttribute('aria-pressed', current === opt.value ? 'true' : 'false');
        card.addEventListener("click", function(){
          state.answers[q.id] = opt.value;
          updateTrustedFormExtras();
          setTimeout(function(){ onNext(); },90);
          render();
        });
        grid.append(card);
      });
      return grid;
    }

    function renderMulti(q){
      const grid = el("div","grid");
      const current = Array.isArray(state.answers[q.id]) ? new Set(state.answers[q.id]) : new Set();
      (q.options || []).forEach(function(opt){
        const card = el("button","choice"); card.type="button";
        const left = el("div",""); left.append(el("div","title", opt.title));
        card.append(left, el("div","", current.has(opt.value) ? "✓" : "+"));
        if(current.has(opt.value)) card.classList.add("selected");
        card.addEventListener("click", function(){
          if(current.has(opt.value)) current.delete(opt.value); else current.add(opt.value);
          state.answers[q.id] = Array.from(current);
          render();
        });
        grid.append(card);
      });
      return grid;
    }

    function renderAddress(q){
      const settings = getQuestionSettings(q);
      const manualHintText = getSettingString(settings, 'manual_hint_text', DEFAULT_STRINGS.manualHint) || DEFAULT_STRINGS.manualHint;
      const fallbackWarningText = getSettingString(settings, 'fallback_warning_text', DEFAULT_STRINGS.fallbackWarning) || DEFAULT_STRINGS.fallbackWarning;
      const addressPlaceholder =
        getSettingString(settings, 'address_placeholder',
          getSettingString(settings, 'placeholder', DEFAULT_STRINGS.addressPlaceholder)
        ) || DEFAULT_STRINGS.addressPlaceholder;
      const wrap = el("div","");
      state.answers.address = state.answers.address || {};
      const autoWrap = el("div","address-autocomplete");
      const auto = el("input","");
      auto.type = "text";
      auto.placeholder = addressPlaceholder;
      auto.autocomplete = "street-address";
      auto.autofocus = true;
      auto.dataset.focusId = "address";
      auto.value = state.answers.address.full || "";
      auto.setAttribute('aria-autocomplete', 'list');
      auto.setAttribute('aria-haspopup', 'listbox');
      const suggestionId = 'addressSuggestions';
      auto.setAttribute('aria-controls', suggestionId);
      auto.setAttribute('aria-expanded', 'false');
      auto.setAttribute('data-tf-element-role','consent-grantor-address');

      const suggestionBox = document.createElement("div");
      suggestionBox.className = "address-suggestions hidden";
      suggestionBox.id = suggestionId;
      suggestionBox.setAttribute('role','listbox');
      suggestionBox.dataset.fallback = 'false';
      suggestionBox.dataset.state = 'hidden';

      autoWrap.append(auto, suggestionBox);
      wrap.append(autoWrap);

      const manualHint = el('div','hint address-manual-hint hidden', manualHintText);
      wrap.append(manualHint);
      lastManualHintEl = manualHint;
      if (state.address_manual_allowed) {
        manualHint.classList.remove('hidden');
      } else {
        manualHint.classList.add('hidden');
      }

      const enableManualHint = () => {
        if (!state.address_manual_allowed) {
          state.address_manual_allowed = true;
        }
        manualHint.classList.remove('hidden');
        lastManualHintEl = manualHint;
      };

      scheduleManualHintDisplay(enableManualHint);

      // Homeowner checkbox (custom styled)
      const own = document.createElement("label");
      own.className = "consent";

      const chk = document.createElement("input");
      chk.type = "checkbox";
      chk.checked = state.is_homeowner !== false;
      chk.className = "visually-hidden";
      chk.addEventListener("change", function(){ state.is_homeowner = chk.checked; });

      const viz = document.createElement("span");
      viz.className = "homeowner-box";

      const txt = document.createElement("div");
      txt.textContent = "I'm the Home Owner";

      own.append(chk, viz, txt);
      wrap.append(own);

      auto.addEventListener("keydown", function(e){
        if (e.key === "Enter") {
          if (suggestionBox.dataset.state === 'options' && suggestions.length) {
            e.preventDefault();
            const idx = activeIndex >= 0 ? activeIndex : 0;
            applySuggestion(idx).catch(()=>{});
            return;
          }
          const fallbackActive = suggestionBox.dataset.fallback === 'true';
          if (fallbackActive || suggestionBox.classList.contains('hidden') || suggestionBox.dataset.state === 'empty') {
            e.preventDefault();
            onNext();
          }
        }
      });

      lazyLoadPlaces().then(async function(ok){
        if(!ok){
        suggestionBox.dataset.fallback = 'true';
        suggestionBox.dataset.state = 'hidden';
        suggestionBox.classList.add('hidden');
        suggestionBox.innerHTML = '';
        auto.setAttribute('aria-expanded','false');
        const warn = document.createElement('div');
        warn.className = 'hint';
        warn.textContent = fallbackWarningText;
        wrap.append(warn);
        enableManualHint();
        return;
      }
        suggestionBox.dataset.fallback = 'false';

        const targetZip = (state.answers.address.zip || state.answers.zip || "").replace(/\D/g,"").slice(0,5);
        const geocoder = new google.maps.Geocoder();
        const detailsCache = new Map();
        let activeIndex = -1;
        let requestSeq = 0;
        let zipBounds = null;
        let zipBias = null;
        let zipMeta = null;
        let suggestions = [];

        function createSuggestionFromPrediction(pred){
          if (!pred) return null;
          const main = pred.mainText || pred.main || (pred.description ? pred.description.split(',')[0] : '');
          const secondary = pred.secondaryText || pred.secondary || '';
          const formatted = pred.description || [main, secondary].filter(Boolean).join(', ');
          const zipHintMatch = (secondary + ' ' + formatted).match(/\b\d{5}(?:-\d{4})?\b/);
          const zipHint = zipHintMatch ? zipHintMatch[0].slice(0,5) : '';
          return {
            placeId: pred.placeId || null,
            main: main || formatted || '',
            secondary,
            formatted: formatted || main || '',
            components: null,
            geometry: null,
            raw: pred.raw || pred,
            zipHint
          };
        }

        function manualSuggestionFromInput(text){
          const line = String(text || '').trim();
          const secondaryParts = [];
          if (targetCityDisplay) secondaryParts.push(targetCityDisplay);
          if (targetStateDisplay) secondaryParts.push(targetStateDisplay);
          if (targetZip) secondaryParts.push(targetZip);
          const secondary = secondaryParts.join(', ');
          const formatted = [line, secondary].filter(Boolean).join(', ');
          return {
            placeId: null,
            main: line || 'Use entered address',
            secondary,
            formatted: formatted || line || '',
            components: {
              street_number: '',
              route: line,
              locality: targetCityDisplay || '',
              postal_town: '',
              sublocality: '',
              sublocality_level_1: '',
              administrative_area_level_3: '',
              administrative_area_level_2: '',
              administrative_area_level_1: targetStateDisplay || '',
              administrative_area_level_1_long: targetStateDisplay || '',
              postal_code: targetZip || ''
            },
            geometry: null,
            raw: null,
            zipHint: targetZip || '',
            manual: true
          };
        }

        async function ensureSuggestionDetails(sugg){
          if (!sugg || sugg.manual) return sugg;
          if (sugg.components && sugg.formatted) return sugg;
          if (sugg.placeId && detailsCache.has(sugg.placeId)) {
            const cached = detailsCache.get(sugg.placeId);
            if (cached) Object.assign(sugg, cached);
            return sugg;
          }
          if (!sugg.placeId) return sugg;
          try {
            const details = await fetchPlaceDetailsFromSuggestion(sugg);
            if (details) {
              const comps = parseAddressComponents(
                details.address_components || details.addressComponents || []
              );
              const formatted =
                details.formatted_address ||
                details.formattedAddress ||
                sugg.formatted ||
                sugg.main ||
                '';
              const geometry = details.geometry || null;
              const enrichment = {
                components: comps,
                formatted,
                geometry,
                zipHint: (comps.postal_code || '').slice(0,5) || sugg.zipHint || ''
              };
              detailsCache.set(sugg.placeId, enrichment);
              Object.assign(sugg, enrichment);
            }
          } catch (err) {
            console.warn('[RoofMetric] address detail fetch failed:', err);
          }
          return sugg;
        }

        function prefetchSuggestionDetails(list){
          list.forEach(function(sugg){
            ensureSuggestionDetails(sugg).catch(()=>{});
          });
        }

        let targetCityDisplay = state.answers.address.city || state.cityGuess || "";
        let targetStateDisplay = state.answers.address.state || state.stateGuess || "";

        if (/^\d{5}$/.test(targetZip)) {
          try {
            state._zipMetaPromise = getZipMetadata(targetZip);
            zipMeta = await state._zipMetaPromise;
            if (zipMeta?.bounds) {
              zipBounds = zipMeta.bounds;
              zipBias = boundsToBias(zipBounds);
            }
            let updatedGuess = false;
            if (zipMeta?.city) {
              if (!state.cityGuess) {
                state.cityGuess = zipMeta.city;
                updatedGuess = true;
              }
              if (!targetCityDisplay) targetCityDisplay = zipMeta.city;
            }
            if (zipMeta?.state) {
              if (!state.stateGuess) {
                state.stateGuess = zipMeta.state;
                updatedGuess = true;
              }
              if (!targetStateDisplay) targetStateDisplay = zipMeta.state;
            }
            if (updatedGuess) updateAreaLabel();
          } catch(_){ zipMeta = null; }
        }
        const targetCityNormalized = (targetCityDisplay || "").toLowerCase();
        const targetStateNormalized = (targetStateDisplay || "").toLowerCase();

        async function fallbackAddressLookup(query){
          if (!targetZip || query.length < 1) return [];
          return new Promise((resolve)=>{
            const cityHint = zipMeta?.city || targetCityDisplay || "";
            const queryString = cityHint ? (query + " " + cityHint + " " + targetZip) : (query + " " + targetZip);
            geocoder.geocode(
              {
                address: queryString,
                componentRestrictions: { country: "US", postalCode: targetZip }
              },
              function(results, status){
                if (status !== "OK" || !Array.isArray(results) || !results.length) {
                  return resolve([]);
                }
                const out = [];
                for (const result of results.slice(0, 10)) {
                  const comps = parseAddressComponents(result.address_components || []);
                  const zipVal = (comps.postal_code || targetZip || '').slice(0,5);
                  const cityVal =
                    comps.locality ||
                    comps.postal_town ||
                    comps.sublocality ||
                    comps.sublocality_level_1 ||
                    comps.administrative_area_level_3 ||
                    comps.administrative_area_level_2 ||
                    comps.neighborhood ||
                    state.cityGuess ||
                    "";
                  const stateVal = comps.administrative_area_level_1 || comps.administrative_area_level_1_long || targetStateDisplay || "";
                  const hasStreet = !!(comps.street_number || comps.route);
                  if (!hasStreet) continue;

                  const mainText = result.formatted_address
                    ? result.formatted_address.split(',')[0].trim()
                    : result.name || query;
                  const parts = [];
                  if (cityVal) parts.push(cityVal);
                  if (stateVal) parts.push(stateVal);
                  if (zipVal) parts.push(zipVal);
                  const secondaryText = parts.join(', ');

                  out.push({
                    placeId: result.place_id || null,
                    formatted: result.formatted_address || mainText,
                    main: mainText,
                    secondary: secondaryText,
                    components: comps,
                    geometry: result.geometry || null,
                    zipHint: zipVal.slice(0,5)
                  });
                }
                resolve(out);
              }
            );
          });
        }

        function setExpanded(state){
          auto.setAttribute('aria-expanded', state ? 'true' : 'false');
        }

        function clearSuggestions(hideOnly){
          suggestions = [];
          activeIndex = -1;
          if (!hideOnly) {
            suggestionBox.innerHTML = '';
          }
          suggestionBox.classList.add('hidden');
          setExpanded(false);
          suggestionBox.dataset.state = 'hidden';
        }

        function renderStatus(html, state){
          suggestionBox.innerHTML = html;
          suggestionBox.classList.remove('hidden');
          setExpanded(true);
          suggestionBox.dataset.state = state || 'message';
        }

        function renderSuggestions(){
          if (!suggestions.length) {
            clearSuggestions();
            return;
          }
          if (activeIndex >= suggestions.length) activeIndex = suggestions.length - 1;
          if (activeIndex < 0) activeIndex = suggestions.length ? 0 : -1;
          suggestionBox.innerHTML = '';
          suggestionBox.dataset.state = 'options';
          suggestions.forEach(function(item, idx){
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'address-suggestion' + (idx === activeIndex ? ' active' : '');
            btn.setAttribute('role','option');
            btn.setAttribute('aria-selected', idx === activeIndex ? 'true' : 'false');
            btn.dataset.index = String(idx);

            const main = document.createElement('div');
            main.className = 'address-suggestion__main';
            main.textContent = item.main || item.formatted || '';
            const secondary = document.createElement('div');
            secondary.className = 'address-suggestion__secondary';
            secondary.textContent = item.secondary || '';

            btn.append(main, secondary);
            btn.addEventListener('mousedown', function(e){ e.preventDefault(); });
            btn.addEventListener('click', function(){ applySuggestion(idx).catch(()=>{}); });
            btn.addEventListener('mouseenter', function(){ activeIndex = idx; refreshActive(); });
            btn.addEventListener('focus', function(){ activeIndex = idx; refreshActive(); });

            suggestionBox.appendChild(btn);
          });
          suggestionBox.classList.remove('hidden');
          setExpanded(true);
          prefetchSuggestionDetails(suggestions.slice(0, 5));
        }

        function refreshActive(){
          const buttons = suggestionBox.querySelectorAll('.address-suggestion');
          buttons.forEach(function(btn, idx){
            if (idx === activeIndex) {
              btn.classList.add('active');
              btn.setAttribute('aria-selected','true');
            } else {
              btn.classList.remove('active');
              btn.setAttribute('aria-selected','false');
            }
          });
        }

        async function applySuggestion(idx){
          const picked = suggestions[idx];
          if (!picked) return;
          const typedValue = auto.value;
          clearSuggestions(false);
          state.address_manual_allowed = false;
          if (lastManualHintEl) lastManualHintEl.classList.add('hidden');
          await ensureSuggestionDetails(picked);
          auto.value = picked.formatted || picked.main || typedValue || '';
          const comp = picked.components || {};
          const derivedZip = (comp.postal_code || targetZip || '').slice(0,5);
          const cityVal =
            comp.locality ||
            comp.postal_town ||
            comp.sublocality ||
            comp.sublocality_level_1 ||
            comp.administrative_area_level_3 ||
            comp.administrative_area_level_2 ||
            comp.neighborhood ||
            targetCityDisplay ||
            "";
          const stateVal = comp.administrative_area_level_1 || comp.administrative_area_level_1_long || targetStateDisplay || "";
          const streetNumber = comp.street_number || "";
          let routeVal = comp.route || "";
          if (!routeVal) {
            const firstPart = (picked.formatted || picked.main || typedValue || '').split(',')[0].trim();
            routeVal = streetNumber ? firstPart.replace(streetNumber, '').trim() : firstPart;
            if (!routeVal) routeVal = firstPart;
          }
          const fullAddress = (picked.formatted || typedValue || '').trim();
          state.answers.address = {
            full: fullAddress,
            street_number: streetNumber,
            route: routeVal || typedValue || '',
            city: cityVal,
            state: stateVal,
            zip: derivedZip || targetZip || ''
          };
          state.answers.address.manual = false;
          if (!state.answers.address.full) state.answers.address.full = typedValue || '';
          state.cityGuess = state.answers.address.city || state.cityGuess;
          state.stateGuess = state.answers.address.state || state.stateGuess;
          updateAreaLabel();
          ensureSessionToken(true);
          setTimeout(function(){ onNext(); },120);
        }

        let debounceTimer = null;
        function scheduleLookup(){
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function(){ performLookup(auto.value); }, 160);
        }

        async function performLookup(query){
          const seq = ++requestSeq;
          const trimmed = String(query || '').trim();

          if (!trimmed) {
            clearSuggestions(true);
            renderStatus('<div class="hint">Start typing your street address.</div>');
            state.answers.address.full = "";
            return;
          }

          renderStatus('<div class="address-suggestions__loading">Looking up addresses…</div>', 'loading');

          const session = ensureSessionToken();
          const fallbackPromise = (targetZip && trimmed.length >= 1)
            ? fallbackAddressLookup(trimmed)
            : Promise.resolve([]);

          const result = await fetchAutocompletePredictions({
            input: trimmed,
            sessionToken: session,
            bounds: zipBounds || null,
            bias: zipBias || null,
            primaryTypes: ['street_address','premise','subpremise','route'],
            regionCode: 'US'
          });
          if (seq !== requestSeq) return;

          let predictions = Array.isArray(result?.predictions) ? result.predictions : [];
          let predictedSuggestions = [];

          if (predictions.length) {
            const mapped = predictions
              .map(createSuggestionFromPrediction)
              .filter(Boolean);

            await Promise.all(
              mapped.slice(0, 10).map(async function(sugg){
                if (!sugg) return;
                if (sugg.placeId && detailsCache.has(sugg.placeId)) {
                  Object.assign(sugg, detailsCache.get(sugg.placeId));
                  return;
                }
                await ensureSuggestionDetails(sugg);
              })
            );
            if (seq !== requestSeq) return;

            let baseSuggestions = mapped;
            if (targetZip) {
              baseSuggestions = mapped.filter(function(sugg){
                if (!sugg) return false;
                const comp = sugg.components || {};
                const compZip = (comp.postal_code || '').slice(0,5);
                const hintZip = (sugg.zipHint || '').slice(0,5);
                if (compZip) return compZip === targetZip;
                if (hintZip) return hintZip === targetZip;
                return false;
              });
            }
            predictedSuggestions = baseSuggestions;
          }

          const fallbackResultsRaw = await fallbackPromise.catch(() => []);
          if (seq !== requestSeq) return;

          const combined = [];
          const seen = new Set();
          function pushIfValid(item){
            if (!item) return;
            const comp = item.components || {};
            const compZip = (comp.postal_code || '').slice(0,5);
            const hintZip = (item.zipHint || '').slice(0,5);
            if (targetZip) {
              if (compZip === targetZip) {
                // ok
              } else if (hintZip === targetZip) {
                // ok
              } else {
                return;
              }
            }
            const key = String(item.formatted || item.main || '').toLowerCase();
            if (!key || seen.has(key)) return;
            seen.add(key);
            combined.push(item);
          }

          (predictedSuggestions || []).forEach(pushIfValid);
          (fallbackResultsRaw || []).forEach(pushIfValid);

          if (combined.length) {
            suggestions = combined;
            activeIndex = 0;
            renderSuggestions();
            return;
          }

          suggestions = [manualSuggestionFromInput(trimmed)];
          activeIndex = 0;
          enableManualHint();
          renderSuggestions();
        }

        auto.addEventListener("input", function(){
          state.answers.address.full = auto.value.trim();
          state.answers.address.manual = state.address_manual_allowed || false;
          scheduleLookup();
        });

        auto.addEventListener("focus", function(){
          if (suggestions.length) {
            renderSuggestions();
          } else if (auto.value.trim()) {
            scheduleLookup();
          }
        });

        auto.addEventListener("blur", function(){
          setTimeout(function(){ clearSuggestions(false); }, 150);
        });

      auto.addEventListener("keydown", function(e){
        if (e.defaultPrevented) return;
        if (!suggestionBox || suggestionBox.classList.contains('hidden')) return;
          if (e.key === "ArrowDown") {
            e.preventDefault();
            if (!suggestions.length) return;
            activeIndex = (activeIndex + 1) % suggestions.length;
            refreshActive();
          } else if (e.key === "ArrowUp") {
            e.preventDefault();
            if (!suggestions.length) return;
            activeIndex = activeIndex <= 0 ? suggestions.length - 1 : activeIndex - 1;
            refreshActive();
          } else if (e.key === "Enter") {
            if (suggestions.length > 0) {
              e.preventDefault();
              const idx = activeIndex >= 0 ? activeIndex : 0;
              applySuggestion(idx).catch(()=>{});
            }
          } else if (e.key === "Escape") {
            e.preventDefault();
            clearSuggestions(false);
          }
        });

        if (auto.value.trim()) {
          scheduleLookup();
        }
      });

      return wrap;
    }

    /* ONE full-name field; still fills name_first/name_last in state */
    function renderName(){
      const wrap = el("div","");
      const full = el("input","");
      full.type = "text";
      full.name = "full_name";
      full.placeholder = "Full name";
      full.autocomplete = "name";
      full.inputMode = "text";
      full.autocapitalize = "words";
      full.spellcheck = false;
      full.enterKeyHint = 'next';
      full.autofocus = true;
      full.dataset.focusId = "name";
      full.setAttribute('data-tf-element-role','consent-grantor-name');

      const current = [state.answers.name_first||"", state.answers.name_last||""].filter(Boolean).join(" ");
      full.value = current;

      function syncName(){
        const parts = full.value.trim().split(/\s+/);
        state.answers.name_first = parts[0] || "";
        state.answers.name_last  = parts.slice(1).join(" ") || "";
      }
      full.addEventListener("input",  syncName);
      full.addEventListener("change", syncName);

      // Enter => Next
      full.addEventListener("keydown", function(e){
        if(e.key === "Enter"){ e.preventDefault(); onNext(); }
      });

      wrap.append(full);

      requestAnimationFrame(function(){
        try{
          full.focus({ preventScroll:true });
          const end = full.value.length;
          if (typeof full.setSelectionRange === "function") full.setSelectionRange(end, end);
        }catch(_){}
      });

      return wrap;
    }

    function renderContact(){
     const wrap = el("div","");
      const email = el("input",""); email.type="email"; email.placeholder="Email"; email.autocomplete="email"; email.value = state.answers.email || "";
      const phone = el("input",""); phone.type="tel";   phone.placeholder="(555) 555-1234"; phone.inputMode="tel"; phone.autocomplete="tel";
      phone.value = formatPhone(state.answers.phone || "");
      email.autocapitalize = 'off';
      email.spellcheck = false;
      email.enterKeyHint = 'next';
      phone.enterKeyHint = 'done';
      email.setAttribute('data-tf-element-role','consent-grantor-email');
      phone.setAttribute('data-tf-element-role','consent-grantor-phone');

      // Autofocus on email (brings up keyboard); also marks this slide for focus
      email.autofocus = true;
      email.dataset.focusId = "contact";

      email.addEventListener("change", function(){ state.answers.email = email.value.trim(); });
      
      // Keep state in sync while typing
      phone.addEventListener("input", function(){
        phone.value = formatPhone(phone.value);
        state.answers.phone = phone.value.trim();
      });
      phone.addEventListener("change", function(){
        state.answers.phone = phone.value.trim();
      });

      // Enter on either input => sync then Next
      email.addEventListener("keydown", function(e){
        if(e.key==="Enter"){
          e.preventDefault();
          state.answers.email = email.value.trim();
          const submitBtn =
            document.querySelector('[data-tf-element-role="submit"]') ||
            document.getElementById('nextBtn');
          if (submitBtn && typeof submitBtn.click === 'function') submitBtn.click();
        }
      });
      phone.addEventListener("keydown", function(e){
        if(e.key==="Enter"){
          e.preventDefault();
          state.answers.phone = phone.value.trim();
          const submitBtn =
            document.querySelector('[data-tf-element-role="submit"]') ||
            document.getElementById('nextBtn');
          if (submitBtn && typeof submitBtn.click === 'function') submitBtn.click();
        }
      });

      const stack = document.createElement("div");
      stack.className = "stack";
      stack.append(email, phone);
     wrap.append(stack);

      // Ensure TrustedForm hidden input exists in the live DOM
      (function ensureTrustedFormField(){
        let tf = document.getElementById(TF_FIELD_NAME);
        if (!tf) {
          tf = document.createElement('input');
          tf.type = 'hidden';
          tf.id = TF_FIELD_NAME;
          tf.name = TF_FIELD_NAME;
          tf.value = '';
          document.body.appendChild(tf);
        }
      })();
      updateTrustedFormExtras();

      const tcpa = document.createElement("div");
      tcpa.className = "hint";
      tcpa.id = "tcpa_text";
      tcpa.setAttribute('data-tf-element-role','consent-language');
      tcpa.innerHTML = 'By clicking <span data-tf-element-role="submit-text">Get Results</span>, I am providing my electronic signature and expressed written consent to permit <strong data-tf-element-role="consent-advertiser-name">RoofMetric</strong> and one local home improvement company to contact me at the number provided to discuss my project <span data-tf-element-role="contact-method">by call or text, including automated messages</span>. I acknowledge my consent is not required to obtain any good or service. See our <a href="https://roofmetric.us/terms/" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;">Terms of Service</a> and <a href="https://roofmetric.us/privacy/" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;">Privacy Policy</a>';
      // Cache TCPA text now (DOM may be replaced by the loading screen)
      state.tcpa_text = tcpa.innerText;

      // Keep the cache fresh if the vendor script mutates the node
      new MutationObserver(() => { state.tcpa_text = tcpa.innerText; })
        .observe(tcpa, { childList: true, subtree: true, characterData: true });
      wrap.append(tcpa);

      // Capture certificate proactively and load TrustedForm immediately so the full journey is covered
      lazyLoadCompliance(true);
      const existingTF = readComplianceFields().tf;
      if (existingTF) state.trustedform_url = existingTF;
      setTimeout(() => {
        waitForComplianceValues(10000).then((ready) => {
          if (!ready) return;
          const { tf } = readComplianceFields();
          if (tf) state.trustedform_url = tf;
        }).catch(()=>{});
      }, 0);

      return wrap;
    }

    
    function onBack(){
      postEvent('step_back', {
        step_elapsed_ms: Date.now() - (state._stepStartMs || state.startedAt)
      });
      state._pendingSubmit = false;
      state._submitInflight = false;
      const targetIndex = findPreviousInteractiveIndex(state.step);
      if (targetIndex < 0) return;
      state.step = targetIndex;
      // entering the previous step: reset the per-step timer and log the new view
      state._stepStartMs = Date.now();
      postEvent('step_view');
      render();
    }

    function showError(msg){
      const err = document.getElementById("err");
      if (!err) return;
      err.textContent = msg;
      err.classList.remove("hidden");
      
      postEvent('step_error', {
        message: String(msg || ''),
        step_elapsed_ms: Date.now() - (state._stepStartMs || state.startedAt)  // <-- ADD
      });

      // Re-enable Next so the user can try again
      const next = document.getElementById('nextBtn');
      if (next) next.disabled = false;

      postHeightSoon();
    }

    async function onNext(){
      try{
        const q = QUESTIONS[state.step];
        const nextEl = document.getElementById('nextBtn');
        if (nextEl) nextEl.disabled = true;
        const err = document.getElementById("err"); if (err){ err.classList.add("hidden"); err.textContent=""; }

        // Generic "required" validation for single/multi steps
        if (q && q.required) {
          if (q.type === "single" && !state.answers[q.id]) {
            return showError("Please select an option to continue.");
          }
          if (q.type === "multi") {
            const arr = state.answers[q.id];
            if (!Array.isArray(arr) || arr.length === 0) {
              return showError("Please select at least one option.");
            }
          }
        }

        if(q.id==="zip"){
          const z = String((state.answers.zip||"").trim());
          if(!/^\d{5}(-\d{4})?$/.test(z)) return showError("Please enter a valid ZIP (e.g. 07733 or 07733-1234).");
          state.answers.address.zip = z.replace(/\D/g,"").slice(0,5);
          postEvent('zip_check_start');
        }

        if(q.id==="address"){
          state.answers.address = state.answers.address || {};
          const a = state.answers.address;
          const fallbackZip = a.zip || state.answers.zip || "";
          const hasStructured = a.full && a.zip;
          const manualEligible = state.address_manual_allowed && a.full && fallbackZip;
          if (manualEligible) {
            if (!a.zip && fallbackZip) {
              a.zip = fallbackZip;
            }
            a.manual = true;
          }
          if(!hasStructured && !manualEligible) {
            requestManualHintDisplay();
            const addrSettings = getQuestionSettings(q);
            const manualErrorCopy = getSettingString(addrSettings, 'manual_error_text', DEFAULT_STRINGS.manualError) || DEFAULT_STRINGS.manualError;
            return showError(manualErrorCopy);
          }
        }

        if(q.id==="name"){
          // Require at least two tokens
          const hasFull = (state.answers.name_first||"").length>0 && (state.answers.name_last||"").length>0;
          if(!hasFull) return showError("Please enter your full name.");
        }

        if(q.id==="contact"){
          if(!isValidEmail(state.answers.email||"")) return showError("Please enter a valid email.");
          if(isDisposableDomain(state.answers.email||"")) return showError("Please use a standard email (no temporary domains).");
          if(!isValidUSPhone(state.answers.phone||"")) return showError("Please enter a valid mobile number.");

          // Best-effort TrustedForm capture (non-blocking)
          lazyLoadCompliance(true);
          const { tf: tfCandidate } = readComplianceFields();
          if (tfCandidate) {
            state.trustedform_url = tfCandidate;
            state.trustedform_override = false;
          }

          // Ensure we have the latest TCPA text before the UI changes
          const tcpaEl = document.getElementById('tcpa_text');
          if (tcpaEl) {
            state.tcpa_text = tcpaEl.innerText;
            const consentCache = document.getElementById('tfConsentCache');
            if (consentCache && !consentCache.contains(tcpaEl)) {
              consentCache.innerHTML = '';
              consentCache.appendChild(tcpaEl);
            }
          }

          postEvent('lead_submit_start');
          state._pendingSubmit = true;
          state._submitInflight = false;
        }

        postEvent('step_next', {
          from: q.id,
          step_elapsed_ms: Date.now() - (state._stepStartMs || state.startedAt)  // <-- ADD
        });

        const advanced = await advanceStep();
        if (!advanced) {
          if (q.id === 'contact') {
            state._pendingSubmit = false;
          }
          showError('Still preparing the next step…');
        }
      }catch(e){ showFatal(e.message||e); }
    }

    function buildStatusMessages(source, fallback){
      if (Array.isArray(source) && source.length) {
        return source
          .map((item) => String(item || '').trim())
          .filter(Boolean);
      }
      return fallback.slice();
    }

    function transitionAutoAdvanceToken(q){
      return q?.question_id || q?.id || '';
    }

    function renderTransitionStep(q){
      if (!stage) return;
      const settings = getQuestionSettings(q);
      stage.innerHTML = "";
      const wrap = document.createElement("div");
      wrap.className = "searching";

      const pill = document.createElement("div");
      pill.className = "pill pill--hero";
      pill.id = "searchHero";
      const templateRaw =
        (typeof settings.pill_template === 'string' && settings.pill_template.trim()) ||
        'Searching in {{city_state}}';
      const labelSpan = document.createElement("span");
      labelSpan.id = "areaLabel";
      labelSpan.textContent = displayCityState();
      const token = /\{\{\s*city_state\s*\}\}/i;
      if (token.test(templateRaw)) {
        const parts = templateRaw.split(token);
        if (parts[0]) pill.append(document.createTextNode(formatLabel(parts[0])));
        pill.append(labelSpan);
        if (parts[1]) pill.append(document.createTextNode(formatLabel(parts[1])));
      } else {
        pill.append(document.createTextNode(formatLabel(templateRaw) + ' '));
        pill.append(labelSpan);
      }
      if (settings.spinner !== false) {
        const dot = document.createElement("span");
        dot.className = "dot dot--live";
        pill.append(dot);
      }
      wrap.appendChild(pill);

      const heading = document.createElement("h2");
      heading.textContent = formatLabel(q.label || settings.title || "Searching…");
      wrap.appendChild(heading);

      const helperCopy = q.sub || settings.description || '';
      if (helperCopy) {
        const helper = document.createElement("p");
        helper.className = "muted";
        helper.textContent = formatLabel(helperCopy);
        wrap.appendChild(helper);
      }

      const ticks = document.createElement("div");
      ticks.className = "ticks";
      wrap.appendChild(ticks);

      stage.innerHTML = "";
      stage.appendChild(wrap);
      stage.setAttribute('data-loading','false');
      stage.setAttribute('aria-busy','false');
      updateFootnoteVisibility();
      if (state.step === 0) {
        notifyFirstStepReady();
      }
      postHeightSoon();

      (function ensureCityFromZip(){
        const label = document.getElementById('areaLabel');
        const z = (state.answers.address.zip || (state.answers.zip||"").replace(/\D/g,"").slice(0,5));
        if(!label || !/^\d{5}$/.test(z)) return;

        if(state.cityGuess){
          label.textContent = state.cityGuess + (state.stateGuess ? (', ' + state.stateGuess) : '');
          return;
        }

        const pending = (state._zipMetaPromise && typeof state._zipMetaPromise.then === 'function')
          ? state._zipMetaPromise
          : getZipMetadata(z);
        state._zipMetaPromise = pending;
        pending.then(function(meta){
          if(!meta) return;
          if(meta.city) state.cityGuess = meta.city;
          if(meta.state) state.stateGuess = meta.state;
          updateAreaLabel();
        }).catch(()=>{});
      })();
      updateAreaLabel();
      if (state._zipMetaPromise && typeof state._zipMetaPromise.then === 'function') {
        state._zipMetaPromise.then(function(){ updateAreaLabel(); }).catch(()=>{});
      }

      const statuses = buildStatusMessages(settings.status_items, [
        "Matching coverage area",
        "Confirming service type",
        "Checking availability",
        "Gathering local cost info"
      ]);
      const stepInterval = Math.max(80, Number(settings.step_interval_ms) || 280);
      const completionDelay = Math.max(0, Number(settings.complete_wait_ms) || 200);
      const autoAdvance = settings.auto_advance !== false;
      const questionToken = transitionAutoAdvanceToken(q);
      let index = 0;
      let advanceScheduled = false;

      function scheduleAdvance(){
        if (advanceScheduled || !autoAdvance) return;
        advanceScheduled = true;
        setTimeout(function(){
          if (state.current_question_id !== questionToken) return;
          advanceStep();
        }, completionDelay);
      }

      (function stepStatuses(){
        if (state.current_question_id !== questionToken) return;
        if(index < statuses.length){
          const text = formatLabel(statuses[index]);
          const row = document.createElement("div");
          row.className = "tick";
          row.innerHTML = '<span class="dot"></span><span>'+escapeHtml(text || '')+'</span>';
          ticks.appendChild(row); index++; postHeightSoon(); setTimeout(stepStatuses, stepInterval);
        } else {
          scheduleAdvance();
        }
      })();

      if (!statuses.length) {
        scheduleAdvance();
      }
    }

    function renderLoadingStep(q){
      if (!stage) return;
      const settings = getQuestionSettings(q);
      stage.innerHTML = "";
      const wrap = document.createElement("div");
      wrap.className = "searching";

      const pill = document.createElement("div");
      pill.className = "pill pill--hero";
      pill.id = "submitHero";
      const label = (typeof settings.countdown_label === 'string' && settings.countdown_label.trim()) || 'Results in';
      const countdown = document.createElement("span");
      countdown.className = "countdown";
      countdown.id = "resultCountdown";
      pill.append(document.createTextNode(formatLabel(label) + " "));
      pill.append(countdown);
      wrap.appendChild(pill);

      const heading = document.createElement("h2");
      heading.textContent = formatLabel(q.label || settings.title || 'Preparing your match…');
      wrap.appendChild(heading);
      const ticks = document.createElement("div");
      ticks.className = "ticks";
      wrap.appendChild(ticks);

      stage.appendChild(wrap);
      stage.setAttribute('data-loading','false');
      stage.setAttribute('aria-busy','false');
      updateFootnoteVisibility();
      if (state.step === 0) {
        notifyFirstStepReady();
      }
      postHeightSoon();

      const statuses = buildStatusMessages(settings.status_items, [
        "Verifying contact details",
        "Securing priority scheduling",
        "Applying available promos",
        "Finalizing your local match"
      ]);
      const stepInterval = Math.max(80, Number(settings.step_interval_ms) || 280);
      (function renderStatuses(){
        if(!statuses.length) return;
        let idx = 0;
        (function addRow(){
          if(idx < statuses.length){
            const row = document.createElement("div");
            row.className = "tick";
            row.innerHTML = '<span class="dot"></span><span>'+escapeHtml(formatLabel(statuses[idx]))+'</span>';
            ticks.appendChild(row);
            idx++;
            postHeightSoon();
            setTimeout(addRow, stepInterval);
          }
        })();
      })();

      const questionToken = transitionAutoAdvanceToken(q);
      const countdownSeconds = Math.max(1, Number(settings.countdown_seconds) || 4);
      let remaining = countdownSeconds;
      countdown.textContent = String(remaining);
      const countdownTimer = setInterval(function(){
        if (state.current_question_id !== questionToken) {
          clearInterval(countdownTimer);
          return;
        }
        remaining -= 1;
        if (remaining <= 0) {
          countdown.textContent = '0';
          clearInterval(countdownTimer);
        } else {
          countdown.textContent = String(remaining);
        }
      }, 1000);

      if (state._pendingSubmit && !state._submitInflight) {
        const submitDelay = Math.max(0, Number(settings.submit_delay_ms) || 220);
        state._submitInflight = true;
        state._pendingSubmit = false;
        setTimeout(function(){
          if (state.current_question_id !== questionToken) return;
          submit();
        }, submitDelay);
      }
    }

    async function advanceStep(){
      if (state.step >= QUESTIONS.length - 1) {
        primeFullFlowFetch();
        if (FULL_FLOW_PROMISE) {
          setNextLoading(true);
          try {
            await FULL_FLOW_PROMISE;
          } catch (_) {
            console.warn('Flow data not ready yet');
          } finally {
            setNextLoading(false);
          }
        }
      }
      if (state.step >= QUESTIONS.length - 1) {
        return false;
      }
      state.step++;
      if (stage && stage.dataset.prerender) {
        stage.dataset.prerender = 'cleared';
      }

      const nextQ = QUESTIONS[state.step];
      if (nextQ) {
        state.current_question_id = nextQ.question_id || nextQ.id || null;
        state.current_position =
          typeof nextQ.source_position === 'number' ? nextQ.source_position : state.step;
      }
      state._stepStartMs = Date.now();
      postEvent('step_view');

      const focusCandidate = nextQ || QUESTIONS[state.step];
      if (focusCandidate && ["text","address","name","contact"].includes(focusCandidate.type)) {
        state.pendingFocusId = focusCandidate.id;
      }
      render();
      return true;
    }

    async function submit(){
      try{
        // Give compliance scripts a moment to populate hidden inputs
        await waitForComplianceValues(3000);

        const { tf: tfCert, tcpa: tcpaText } = readComplianceFields();
        if (!tfCert) console.warn('TrustedForm cert missing at submit (likely blocked).');
        const finalTcpaText = String(tcpaText || state.tcpa_text || '').trim();

        const questionMapPayload = {};
        const registerQuestionKey = (key, id) => {
          if (!key || !id) return;
          const trimmed = String(key).trim();
          if (!trimmed) return;
          questionMapPayload[trimmed] = id;
          questionMapPayload[trimmed.toLowerCase()] = id;
        };
        if (Array.isArray(QUESTIONS)) {
          QUESTIONS.forEach((q) => {
            if (!q) return;
            const raw = q.raw || {};
            const backendId = raw.id || raw.question_id || q.question_id || null;
            if (!backendId) return;
            registerQuestionKey(q.id, backendId);
            registerQuestionKey(q.analytics_key, backendId);
            registerQuestionKey(raw.analytics_key, backendId);
            registerQuestionKey(raw.id, backendId);
            registerQuestionKey(raw.question_id, backendId);
          });
        }

        const payload = {
          source: "roofmetric-quiz",
          timestamp: new Date().toISOString(),
          duration_sec: Math.round((Date.now()-state.startedAt)/1000),
          session_id: rmSessionId(),
          page_url: location.href,
        consent_version: "2025-01-15 / v1.0",
        answers: state.answers,
        is_homeowner: !!state.is_homeowner,
        utm: state.utms,
        referrer: state.ref,
        hp: state.honeypot,
        trustedform_url: tfCert || state.trustedform_url || '',
        tcpa_text: finalTcpaText,
        copy_variant: state.copy_variant || '',
        flow_variant: state.flow_variant || '',
        variant_id: state.variant_id || window.__RM_VARIANT_ID__ || '',
        project_id: state.project_id || RM_CONFIG.projectId || null,
        question_map: questionMapPayload,
        copy: { reasons: [] }
      };

        // Supabase Edge Function (roofmatch)
        await BOOTSTRAP_PROMISE;
        const base = getApiBase();
        fetch(base, {
          method: 'POST',
          headers: sbHeaders(),
          body: new URLSearchParams({
            endpoint: 'submit',
            payload: JSON.stringify(payload)
          })
        })
          .then(r => r.json())
          .then(resp => renderResult(resp || { matched:false }))
          .catch(err => {
            console.warn('Network/parse error:', err);
            renderResult({ matched:false });
          });

      }catch(e){ showFatal(e.message||e); }
    }

    let _calendarReady = false;
    function ensureCalendarFns(){
      if(_calendarReady) return;
      _calendarReady = true;

      // === moved calendar functions start ===

      // renderNativeCalendar
       /* === Native Calendar ===
    - 7-day window: tomorrow through +7 days (inclusive)
    - Slots: 9:00 AM to 7:00 PM every 30 minutes (local time)
    - Reuses collected name/email/phone from state.answers
      */
      function renderNativeCalendar(provider, availability){
        const mount = document.getElementById('nativeCalendarMount');
        if(!mount) return;

        const wrap = document.createElement('div');
        wrap.className = 'calendar-body';

        const cal = document.createElement('div');
        cal.className = 'cal';
        wrap.appendChild(cal);

        // Head
        const head = document.createElement('div');
        head.className = 'cal-head';
        const stepLabel = document.createElement('div');
        stepLabel.className = 'cal-step';
        stepLabel.textContent = 'Step 1 · Pick a date';
        head.append(stepLabel);
        cal.appendChild(head);

        // Days
        const daysRow = document.createElement('div');
        daysRow.className = 'cal-days';
        cal.appendChild(daysRow);

        // Slots
        const slotsWrap = document.createElement('div');
        slotsWrap.className = 'cal-slots';
        cal.appendChild(slotsWrap);
        slotsWrap.style.display = 'none'; // hide initially

        // Note + CTA
        const note = document.createElement('div');
        note.className = 'cal-note';
        note.textContent = 'Choose a date to see available times.';
        cal.appendChild(note);

        const ctaRow = document.createElement('div');
        ctaRow.className = 'cal-cta';
        const confirmDefaultText = 'Confirm time';
        const confirmBtn = button(confirmDefaultText,'', onConfirm);
        confirmBtn.disabled = true;  // enabled only after a time is selected
        ctaRow.append(confirmBtn);
        cal.appendChild(ctaRow);

        mount.appendChild(wrap);

        postEvent('booking_open');

        postHeightAggressively();  // recalc iframe height

        let selectedDateTimeISO = null;   // for display only (local string like '2025-10-25T09:30:00')
        let selectedLocalDate = '';       // 'YYYY-MM-DD'
        let selectedLocalTime = '';       // 'HH:MM'
        let selectedDisplayDateLabel = '';
        let selectedDisplayTimeLabel = '';

        /* helper: HH:MM -> h:mm AM/PM */
        function to12h(hhmm){
          const [hStr, mStr] = String(hhmm).split(':');
          const h = Number(hStr), m = Number(mStr);
          const ampm = h >= 12 ? 'PM' : 'AM';
          const h12 = (h % 12) || 12;
          return h12 + ':' + String(m).padStart(2,'0') + ' ' + ampm;
        }

        /* helper: YYYY-MM-DD + HH:MM -> ISO (best effort local) */
        function localIsoFromParts(ymd, hm){
          // Interprets the parts in the browser's local TZ, good enough for UI + server stores raw parts.
          return new Date(ymd + 'T' + hm + ':00').toISOString();
        }

        /* Decide data source: server days (if present) or local fallback */
        const serverDays = (availability && Array.isArray(availability.days) && availability.days.length > 0) ? availability.days : null;

        if (serverDays) {
          // --- SERVER-DRIVEN DAYS ---
          serverDays.forEach(function(d){
            // d: { date: 'YYYY-MM-DD', label: 'Thu, Jan 23', slots: ['09:00','09:30',...] }
            const cell = document.createElement('div');
            cell.className = 'cal-day';
            const parts = d.label.split(',');
            const dow   = (parts[0] || '').trim();
            const mon   = ((parts[1] || '').trim().split(' ')[0] || '');
            const day   = String(d.date).split('-')[2];

            cell.innerHTML = '<div class="dow">'+ dow +'</div>'
              + '<div class="date">'+ day +'</div>'
              + '<div class="month">'+ mon +'</div>';

            cell.addEventListener('click', function(){
              selectedDateTimeISO = null;
              selectedLocalDate = d.date;      // keep raw 'YYYY-MM-DD'
              selectedLocalTime = '';
              selectedDisplayDateLabel = d.label || '';
              selectedDisplayTimeLabel = '';
              confirmBtn.disabled = true;

              Array.from(daysRow.children).forEach(function(n){ n.classList.remove('selected'); });
              cell.classList.add('selected');
              postEvent('booking_day', { date: d.date, tz: (availability && availability.tz) || (provider && provider.tz) || '' });

              stepLabel.textContent = 'Step 2 · Choose a time';
              note.textContent = 'Pick a time on ' + d.label;

              // show slots
              slotsWrap.style.display = 'grid';
              slotsWrap.innerHTML = '';

              const slots = Array.isArray(d.slots) ? d.slots : [];
              if (slots.length === 0) {
                const none = document.createElement('div');
                none.className = 'cal-note';
                none.textContent = 'No times available for this day.';
                slotsWrap.parentElement && slotsWrap.parentElement.insertBefore(none, slotsWrap.nextSibling);
              } else {
                slots.forEach(function(hm){ // 'HH:MM'
                  const btn = document.createElement('button');
                  btn.type = 'button';
                  btn.className = 'cal-slot';
                  btn.textContent = to12h(hm);
                  btn.addEventListener('click', function(){
                    selectedLocalTime = hm;                                   // keep raw 'HH:MM'
                    selectedDateTimeISO = `${selectedLocalDate}T${hm}:00`;    // local string for display
                    selectedDisplayTimeLabel = to12h(hm);
                    Array.from(slotsWrap.children).forEach(n => n.classList.remove('selected'));
                    btn.classList.add('selected');
                    postEvent('booking_slot', { date: selectedLocalDate, time: hm });
                    confirmBtn.disabled = !(selectedLocalDate && selectedLocalTime);
                  });
                  slotsWrap.appendChild(btn);
                });
              }

              postHeightAggressively();
            });

            daysRow.appendChild(cell);
          });

} else {
  // --- LOCAL FALLBACK (your existing 7-day/30-min grid) ---
  const dayObjs = buildSevenDayWindow();

  dayObjs.forEach(function(d){
    const cell = document.createElement('div');
    cell.className = 'cal-day';
    cell.innerHTML = '<div class="dow">'+ d.dow +'</div>'
      + '<div class="date">'+ d.day +'</div>'
      + '<div class="month">'+ d.mon +'</div>';

    cell.addEventListener('click', function(){
      selectedDateTimeISO = null;
      selectedLocalTime = '';
      selectedDisplayDateLabel = shortHumanDate(d.date);
      selectedDisplayTimeLabel = '';
      confirmBtn.disabled = true;

      Array.from(daysRow.children).forEach(function(n){ n.classList.remove('selected'); });
      cell.classList.add('selected');
      postEvent('booking_day', { date: d.date.toISOString() });

      stepLabel.textContent = 'Step 2 · Choose a time';
      note.textContent = 'Pick a time on ' + shortHumanDate(d.date);

      // derive 'YYYY-MM-DD' for this local day
      const y = d.date.getFullYear();
      const m = String(d.date.getMonth()+1).padStart(2,'0');
      const da = String(d.date.getDate()).padStart(2,'0');
      selectedLocalDate = `${y}-${m}-${da}`;

      slotsWrap.style.display = 'grid';
      slotsWrap.innerHTML = '';

      // render slots and get back the selected 'HH:MM'
      renderSlotsForDay(d, slotsWrap, function(hm, labelText){
        selectedLocalTime = hm;                                  // 'HH:MM'
        selectedDateTimeISO = `${selectedLocalDate}T${hm}:00`;   // local string for display
        selectedDisplayTimeLabel = labelText || '';
        confirmBtn.disabled = !(selectedLocalDate && selectedLocalTime);
      });

      postHeightAggressively();
    });

    daysRow.appendChild(cell);
  });
}

        // (intentionally no auto-select; user must pick a date first)

        function onConfirm(){
          postEvent('booking_confirm_click', { local_date: selectedLocalDate, local_time: selectedLocalTime });
          if (!selectedLocalDate || !selectedLocalTime) return;

          // Build payload reusing collected contact info
          const fullName = [state.answers.name_first||'', state.answers.name_last||''].filter(Boolean).join(' ').trim();
          const tzGuess = (provider && provider.tz) || (Intl.DateTimeFormat().resolvedOptions().timeZone || '');

          const leadKey = state.lead_key || '';
          const bookingEventId = (leadKey || state.lead_id || '')
            ? ((leadKey || state.lead_id) + ':booking:' + selectedLocalDate + ':' + selectedLocalTime)
            : '';

          const bookingPayload = {
            // identifiers
            partner_id: (provider && (provider.id || provider.partner_id || provider.provider_id)) || '',
            provider_id: (provider && (provider.id || provider.partner_id || provider.provider_id)) || '',
            lead_id: state.lead_id || null,
            lead_key: leadKey,

            // requested local appointment (server can canonicalize to UTC)
            local_date: selectedLocalDate,    // 'YYYY-MM-DD'
            local_time: selectedLocalTime,    // 'HH:MM'
            tz: (provider && provider.tz) || (Intl.DateTimeFormat().resolvedOptions().timeZone || ''),

            // contact details already collected
            name: [state.answers.name_first||'', state.answers.name_last||''].filter(Boolean).join(' ').trim(),
            email: state.answers.email || '',
            phone: normalizePhone(state.answers.phone || ''),

            // helpful context
            zip: (state.answers.address && state.answers.address.zip) || (state.answers.zip||'').replace(/\D/g,'').slice(0,5) || '',
            address_full: (state.answers.address && state.answers.address.full) || '',
            city: (state.answers.address && state.answers.address.city) || state.cityGuess || '',
            state: (state.answers.address && state.answers.address.state) || state.stateGuess || '',
            source: 'roofmetric-quiz',
            utm: state.utms,
            referrer: state.ref,
            session_id: rmSessionId(),
            page_url: location.href,
            copy_variant: state.copy_variant || ''
          };
          bookingPayload.meta_event_id = bookingEventId;

          // small inline feedback
          confirmBtn.disabled = true;
          confirmBtn.textContent = 'Booking...';

          const _bookingTimeout = setTimeout(function(){
            postEvent('booking_timeout');
            confirmBtn.disabled = false;
            confirmBtn.textContent = confirmDefaultText;
            showError('Network is slow. Please try again.');
          }, 15000);

          function handleBookingSuccess(){
            clearTimeout(_bookingTimeout);
            postEvent('booking_success');
            if (typeof window !== 'undefined' && window.__RM_ENABLE_META && typeof window.fbq === 'function') {
              try {
                const metaPayload = {
                  currency: 'USD',
                  value: 0,
                  status: 'booked',
                  appointment_date: selectedLocalDate,
                  appointment_time: selectedLocalTime,
                  timezone: bookingPayload.tz || ''
                };
                if (bookingPayload.meta_event_id) {
                  window.fbq('track', 'Schedule', metaPayload, { eventID: bookingPayload.meta_event_id });
                } else {
                  window.fbq('track', 'Schedule', metaPayload);
                }
              } catch (_) {}
            }
            showBookingConfirmation({
              provider: provider || {},
              localDate: selectedLocalDate,
              localTime: selectedLocalTime,
              displayDateLabel: selectedDisplayDateLabel,
              displayTimeLabel: selectedDisplayTimeLabel,
              iso: selectedDateTimeISO,
              tz: bookingPayload.tz,
              durationMinutes: 30,
              leadKey: state.lead_key || '',
              leadId: state.lead_id || ''
            });
          }

          // === Send booking to server (API_BASE) ===
            BOOTSTRAP_PROMISE.then(() => {
              return fetch(getApiBase(), {
                method: 'POST',
                headers: sbHeaders(),
                body: new URLSearchParams({
                  endpoint: 'book',
                  payload: JSON.stringify(bookingPayload)
                })
              });
            })
            .then(async r => {
              const text = await r.text();
              let json;
              try { json = JSON.parse(text); } catch (_) {}
              if (!r.ok || !json || json.ok !== true) {
                console.warn('BOOK ERROR', { status: r.status, body: text, payload: bookingPayload });
                postEvent('booking_error_detail', { status: r.status, body: String(text).slice(0, 800) });
                throw new Error('Booking failed');
              }
              return json;
            })
            .then(() => {
              handleBookingSuccess();
            })
            .catch((e) => {
              clearTimeout(_bookingTimeout);
              postEvent('booking_error');
            confirmBtn.disabled = false;
            confirmBtn.textContent = confirmDefaultText;
            showError('Couldn’t complete booking. Please try again.');
            console.error(e);
          });
          }
        }

      /* Build the 7-day window: tomorrow through +7 days (inclusive) */
      function buildSevenDayWindow(){
        const out = [];
        const now = new Date();
        for(let i=1;i<=7;i++){
          const d = new Date(now);
          d.setDate(now.getDate() + i);
          out.push({
            date: new Date(d.getFullYear(), d.getMonth(), d.getDate()),
            dow: d.toLocaleDateString(undefined,{ weekday:'short'}),
            mon: d.toLocaleDateString(undefined,{ month:'short'}),
            day: d.getDate()
          });
        }
        return out;
      }

      /* Render 30-min slots from 9:00 to 7:00 PM local */
      function renderSlotsForDay(dayObj, mount, onPick){
        mount.innerHTML = '';
        const base = new Date(dayObj.date);

        // Start 09:00, End 19:00 (inclusive start)
        const startMinutes = 9*60;
        const endMinutes   = 19*60;
        const step = 30;

        const slots = [];
        for(let m=startMinutes; m<=endMinutes; m+=step){
          const dt = new Date(base);
          dt.setHours(0,0,0,0);
          dt.setMinutes(m);
          slots.push(dt);
        }

        slots.forEach(function(dt){
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cal-slot';

          // Display time in user's locale, but keep a raw 'HH:MM' value to send
          const hm = dt.toTimeString().slice(0,5); // 'HH:MM'
          btn.textContent = dt.toLocaleTimeString([], {hour:'numeric', minute:'2-digit'});

          btn.addEventListener('click', function(){
            postEvent('booking_slot', { time: hm });
            Array.from(mount.children).forEach(n => n.classList.remove('selected'));
            btn.classList.add('selected');
            if (typeof onPick === 'function') onPick(hm, btn.textContent);
          });
          mount.appendChild(btn);
        });
      }

      /* Formatting helpers */
      function shortHumanDate(d){
        try { return d.toLocaleDateString([], { weekday:'short', month:'short', day:'numeric'}); }
        catch(_){ return String(d); }
      }
      function niceDateTime(iso){
        try {
          const dt = new Date(iso);
          return dt.toLocaleString([], { weekday:'short', month:'short', day:'numeric', hour:'numeric', minute:'2-digit' });
        } catch(_) { return iso; }
      }

      function normalizeUrl(url){
        if (!url) return '';
        var trimmed = String(url).trim();
        if (!trimmed) return '';
        if (/^(https?:)?\/\//i.test(trimmed)) {
          return trimmed.replace(/^(https?:)?\/\//i, function(match){
            return match.startsWith('http') ? match : 'https://';
          });
        }
        return 'https://' + trimmed.replace(/^\/+/, '');
      }

      function buildCalendarLinks(opts){
        opts = opts || {};
        var start = opts.start instanceof Date ? opts.start : new Date();
        var durationMinutes = opts.durationMinutes || 30;
        var end = new Date(start.getTime() + durationMinutes * 60000);
        var encodeCalDate = function(date){
          return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
        };
        var title = opts.title || 'Roof Inspection';
        var description = (opts.description || '').replace(/\r?\n/g, '\\n');
        var google = 'https://calendar.google.com/calendar/render?action=TEMPLATE'
          + '&text=' + encodeURIComponent(title)
          + '&dates=' + encodeCalDate(start) + '/' + encodeCalDate(end)
          + '&details=' + encodeURIComponent(opts.description || '')
          + (opts.location ? '&location=' + encodeURIComponent(opts.location) : '')
          + '&sf=true&output=xml';
        var uid = opts.uid || ('rm-' + Math.random().toString(36).slice(2, 10));
        var icsLines = [
          'BEGIN:VCALENDAR',
          'VERSION:2.0',
          'PRODID:-//RoofMetric//EN',
          'BEGIN:VEVENT',
          'UID:' + uid,
          'DTSTAMP:' + encodeCalDate(new Date()),
          'DTSTART:' + encodeCalDate(start),
          'DTEND:' + encodeCalDate(end),
          'SUMMARY:' + title,
          opts.location ? 'LOCATION:' + opts.location : null,
          'DESCRIPTION:' + description,
          'END:VEVENT',
          'END:VCALENDAR'
        ].filter(Boolean).join('\\r\\n');
        var apple = {
          href: 'data:text/calendar;charset=utf-8,' + encodeURIComponent(icsLines),
          filename: 'roofmetric-booking.ics'
        };
        return { google: google, apple: apple };
      }

      function setupPrepChecklist(listEl, messageEl){
        if (!listEl) return;
        var items = Array.from(listEl.querySelectorAll('.prep-item'));
        function updateMessage(){
          var allDone = items.length > 0 && items.every(function(btn){
            return btn.getAttribute('aria-pressed') === 'true';
          });
          if (messageEl) {
            messageEl.classList.toggle('is-visible', allDone);
          }
        }
        items.forEach(function(btn){
          btn.addEventListener('click', function(){
            var pressed = btn.getAttribute('aria-pressed') === 'true';
            var nextState = !pressed;
            btn.setAttribute('aria-pressed', nextState ? 'true' : 'false');
            btn.classList.toggle('is-done', nextState);
            var icon = btn.querySelector('.prep-icon');
            if (icon) icon.textContent = nextState ? '☑️' : '☐';
            updateMessage();
          });
          btn.setAttribute('aria-pressed', 'false');
          btn.classList.remove('is-done');
          var icon = btn.querySelector('.prep-icon');
          if (icon) icon.textContent = '☐';
        });
        updateMessage();
      }

      function postBookingCompletionAdjustments(){
        postHeightAggressively('aggressive');
        [0, 200, 600, 1200].forEach(function(delay){
          setTimeout(function(){
            var h = measureDoc();
            postToParent({ type:'RM_IFRAME_HEIGHT', height:h, allowShrink:true });
          }, delay);
        });
        postToParent({ type:'RM_IFRAME_SCROLL_TOP' });
      }

      function appointmentLabelFromParts(displayDate, displayTime, fallbackIso){
        if (displayDate && displayTime) {
          return displayDate + ' at ' + displayTime;
        }
        if (fallbackIso) return niceDateTime(fallbackIso);
        return 'your confirmed time';
      }

    function showBookingConfirmation(opts){
      opts = opts || {};
      var provider = opts.provider || {};
      var displayDate = opts.displayDateLabel || '';
      var displayTime = opts.displayTimeLabel || '';
      var appointmentLabel = appointmentLabelFromParts(displayDate, displayTime, opts.iso);
      var companyName = provider.company || 'our vetted partner';
      var websiteRaw = provider.website_url || provider.website || provider.booking_url || '';
      var websiteUrl = normalizeUrl(websiteRaw);
      var start = opts.iso ? new Date(opts.iso) : new Date((opts.localDate && opts.localTime) ? (opts.localDate + 'T' + opts.localTime + ':00') : Date.now());
      if (isNaN(start.getTime())) start = new Date();
      var calendarLinks = buildCalendarLinks({
        start: start,
        durationMinutes: opts.durationMinutes || 30,
        title: 'Roof Inspection — ' + companyName,
        description: companyName + ' will confirm your crew lead soon. Scheduled via RoofMetric.',
        location: provider.city && provider.state ? (provider.city + ', ' + provider.state) : (provider.city || ''),
        uid: opts.leadKey || opts.leadId || ('rm-' + Math.random().toString(36).slice(2, 10))
      });
      var bookingCopy = resolveBookingCopy(provider);
      var copyTokens = buildTemplateTokens(provider, {
        appointment_label: appointmentLabel,
        appointment: appointmentLabel
      });
      var pillText = formatTemplate(bookingCopy.pill, copyTokens) || bookingCopy.pill || DEFAULT_BOOKING_COPY.pill;
      var headlineText = formatTemplate(bookingCopy.headline_template, copyTokens) || ('You’re booked for ' + appointmentLabel + '.');
      var subheadText = formatTemplate(bookingCopy.subhead_template, copyTokens) || ('Thanks, ' + companyName + ' will reach out to you ASAP with final confirmation and your crew lead’s name.');
      var ctaGoogle = bookingCopy.cta_google || DEFAULT_BOOKING_COPY.cta_google;
      var ctaApple = bookingCopy.cta_apple || DEFAULT_BOOKING_COPY.cta_apple;
      var ctaPartner = formatTemplate(bookingCopy.cta_partner, copyTokens) || ('Go To ' + companyName);
      var checklistItems = Array.isArray(provider.booking_checklist) && provider.booking_checklist.length
        ? provider.booking_checklist
        : PREP_ITEMS;
      var checklistHtml = checklistItems.map(function(item, idx){
        return '<button type="button" class="prep-item" data-prep="'+idx+'" aria-pressed="false">'
          + '<span class="prep-icon" aria-hidden="true">☐</span>'
          + '<span class="prep-text">' + escapeHtml(String(item || '')) + '</span>'
          + '</button>';
      }).join('');
      stage.innerHTML = ''
        + '<div class="booking-confirm fade-enter fade-enter-active">'
        +   '<div class="pill">'+ escapeHtml(pillText) +'</div>'
        +   '<h1 class="booking-headline">'+ escapeHtml(headlineText) +'</h1>'
        +   '<p class="booking-subhead">'+ escapeHtml(subheadText) +'</p>'
        +   '<div class="confirm-actions">'
        +     '<a class="btn secondary" data-cal="google" href="#" target="_blank" rel="noopener">'+ escapeHtml(ctaGoogle) +'</a>'
        +     '<a class="btn secondary" data-cal="apple" href="#" download="roofmetric-booking.ics">'+ escapeHtml(ctaApple) +'</a>'
        +     (websiteUrl ? '<a class="btn visit-btn" data-partner-site="true" href="' + escapeAttr(websiteUrl) + '" target="_blank" rel="noopener">'+ escapeHtml(ctaPartner) +'</a>' : '')
        +   '</div>'
        +   '<div class="prep-section">'
        +     '<h2>'+ escapeHtml(bookingCopy.checklist_headline || DEFAULT_BOOKING_COPY.checklist_headline) +'</h2>'
        +     '<p class="prep-subhead">'+ escapeHtml(bookingCopy.checklist_subhead || DEFAULT_BOOKING_COPY.checklist_subhead) +'</p>'
        +     '<div class="prep-checklist" role="list">' + checklistHtml + '</div>'
        +     '<div class="prep-complete-msg" aria-live="polite">'+ escapeHtml(bookingCopy.completion_message || DEFAULT_BOOKING_COPY.completion_message) +'</div>'
        +   '</div>'
        + '</div>';

      var googleBtn = stage.querySelector('[data-cal="google"]');
      if (googleBtn && calendarLinks.google) googleBtn.href = calendarLinks.google;
      var appleBtn = stage.querySelector('[data-cal="apple"]');
      if (appleBtn && calendarLinks.apple) {
        appleBtn.href = calendarLinks.apple.href;
        appleBtn.setAttribute('download', calendarLinks.apple.filename);
      }
      var checklistEl = stage.querySelector('.prep-checklist');
      var messageEl = stage.querySelector('.prep-complete-msg');
      setupPrepChecklist(checklistEl, messageEl);
      postBookingCompletionAdjustments();
    }


      // expose them to the outer scope (so existing calls still work)
      window.renderNativeCalendar = renderNativeCalendar;
      window.buildSevenDayWindow  = buildSevenDayWindow;
      window.renderSlotsForDay    = renderSlotsForDay;
      window.shortHumanDate       = shortHumanDate;
      window.niceDateTime         = niceDateTime;
    }

    function renderResult(data){
      try{
        // Attach lead_id once (and emit telemetry)
        const newLeadId =
          (data && (data.lead_id || (data.lead && data.lead.id))) || null;
        const leadKey = (data && (data.lead_key || data.leadKey)) || null;
        if (newLeadId && state.lead_id !== newLeadId) {
          state.lead_id = newLeadId;
          postEvent('lead_id_attached', { lead_id: state.lead_id });
        }
        if (leadKey) state.lead_key = leadKey;
        if(data && data.matched){
        postEvent('result_matched', { company: (data.provider && data.provider.company) || '' });
        const c = data.provider || {};
        // normalize provider id for downstream API calls
        const providerId = (c.id || c.partner_id || c.provider_id || '') || '';
        state.partner_id = providerId;
        updateTrustedFormExtras();
        const copy = data.copy || {};
        const reasonsRaw = Array.isArray(copy.reasons) ? copy.reasons : [];
        const reasonsFiltered = reasonsRaw.filter(function(r){ return !/^track\s*record:/i.test(r); });
        const financingLine = reasonsFiltered.find(function(r){ return /^financing:/i.test(r); }) || "";
        const financingText = financingLine.replace(/^financing:\s*/i, "");

        const companyName = c.company || 'your local roofer';
        const templateTokens = buildTemplateTokens(c);
        const heroCopy = resolveHeroCopy(c);
        const heroBrand = escapeHtml(heroCopy.brand || DEFAULT_HERO_COPY.brand);
        const heroPill = escapeHtml(heroCopy.pill || DEFAULT_HERO_COPY.pill);
        const heroEyebrow = escapeHtml(heroCopy.eyebrow || DEFAULT_HERO_COPY.eyebrow);
        let heroHeadline;
        if (heroCopy.headline_template) {
          const rawHeadline = formatTemplate(heroCopy.headline_template, templateTokens);
          const companyEscaped = escapeHtml(companyName);
          let escapedHeadline = escapeHtml(rawHeadline || '');
          if (companyEscaped && escapedHeadline.includes(companyEscaped)) {
            escapedHeadline = escapedHeadline.replace(
              companyEscaped,
              '<span class="match-company-accent">'+ companyEscaped +'</span>'
            );
          }
          heroHeadline = escapedHeadline || 'You\'re matched with <span class="match-company-accent">'+ companyEscaped +'</span>';
        } else {
          heroHeadline = 'You\'re matched with <span class="match-company-accent">'+ escapeHtml(companyName) +'</span>';
        }
        const heroSubheadFromCopy = heroCopy.subhead
          ? highlightCompanyInSubhead(formatTemplate(heroCopy.subhead, templateTokens), c.company)
          : null;
        const fallbackSubhead = copy.subhead
          ? highlightCompanyInSubhead(copy.subhead, c.company)
          : highlightCompanyInSubhead(DEFAULT_HERO_COPY.subhead, c.company);
        const heroSubhead = heroSubheadFromCopy || fallbackSubhead;

        // Native calendar replaces external booking widgets
        const calendarCard = buildCalendarCard(c);
        const promosCard = buildPromoCard(c);
        const callCard = buildCallCard(c);

        const heroMetrics = buildHeroMetrics(c, financingText);
        const heroMetricsHTML = heroMetrics.map(function(item){
          return '<div class="rm-hero-metric"><strong>'+ escapeHtml(item.value) +'</strong><span>'+ escapeHtml(item.label) +'</span></div>';
        }).join('');
        const trustNotes = buildTrustNotes(c);
        const trustRowHTML = trustNotes.length
          ? '<div class="rm-trust-row">' + trustNotes.map(function(note, idx){
              const text = escapeHtml(note);
              return idx === 0 ? '<span class="accent-highlight">'+ text +'</span>' : text;
            }).join(' • ') + '</div>'
          : '';

        const eventId = (state.lead_key || state.lead_id || '') || '';
        if (typeof window !== 'undefined' && window.__RM_ENABLE_META && typeof window.fbq === 'function') {
          try {
            if (eventId) {
              window.fbq('track', 'Lead', { currency: 'USD', value: 0 }, { eventID: eventId });
            } else {
              window.fbq('track', 'Lead', { currency: 'USD', value: 0 });
            }
          } catch (_) {}
        }

        stage.innerHTML =
          '<main class="rm-match-page">'
        +   '<section class="rm-hero">'
        +     '<div class="rm-hero-top">'
        +       '<span class="rm-hero-brand accent-green">'+ heroBrand +'</span>'
        +       '<span class="rm-hero-pill">'+ heroPill +'</span>'
        +     '</div>'
        +     '<div class="rm-hero-eyebrow">'+ heroEyebrow +'</div>'
        +     '<h1>'+ heroHeadline +'</h1>'
        +     '<p class="lede">'+ heroSubhead +'</p>'
        +     '<div class="rm-hero-grid">'+ heroMetricsHTML +'</div>'
        +   '</section>'
        +   trustRowHTML
        +   '<section class="rm-layout">'
        +     '<div class="rm-primary">'
        +       (promosCard || '')
        +       (callCard || '')
        +       (calendarCard || '')
        +     '</div>'
        +   '</section>'
        + '</main>';

        postHeightAggressively();
        initPromoCountdown(stage);

        document.body.classList.add('has-booking');
        ensureCalendarFns();

        // Try server-provided availability; fall back to local
        BOOTSTRAP_PROMISE.then(() => {
          return fetch(getApiBase(), {
            method: 'POST',
            headers: sbHeaders(),
            body: new URLSearchParams({
              endpoint: 'availability',
              payload: JSON.stringify({ partner_id: providerId })
            })
          });
        })
        .then(r => r.json())
        .then(av => {
          renderNativeCalendar(Object.assign({}, c, { id: providerId }), av && av.days ? av : null);
        })
        .catch(() => {
          renderNativeCalendar(Object.assign({}, c, { id: providerId }), null); // fallback
        });

        postHeightAggressively();

    } else {
      postEvent('result_unmatched');
      state.partner_id = '';
      updateTrustedFormExtras();
          showTY(data && data.ty_copy ? data.ty_copy : null);
        }
      }catch(e){ showFatal(e.message||e); }
    }

    function buildTrustNotes(provider){
      const custom = Array.isArray(provider?.trust_notes)
        ? provider.trust_notes.map(function(note){
            return String(note || '').trim();
          }).filter(Boolean)
        : [];
      if (custom.length) return custom.slice(0, 2);
      const defaults = [];
      const fallback = buildTrustLine(provider);
      if (fallback) defaults.push(fallback);
      defaults.push('Backed by the RoofMetric Guarantee');
      return defaults;
    }

    function buildTrustLine(provider){
      const area = describeServiceArea(provider);
      if (!area) return 'Trusted by homeowners near you';
      return 'Trusted by homeowners across ' + area;
    }

function describeServiceArea(provider){
  const raw = (provider && (provider.state || provider.state_code || provider.service_state)) || '';
  const trimmed = String(raw || '').trim();
  if (!trimmed) return '';
  const upper = trimmed.toUpperCase();
  if (typeof STATE_MAP !== 'undefined' && STATE_MAP && STATE_MAP[upper]) return STATE_MAP[upper];
  return trimmed;
}

    function buildHeroMetrics(provider, financingText){
      const custom = Array.isArray(provider?.hero_metrics)
        ? provider.hero_metrics.map(function(item){
            if (!item || typeof item !== 'object') return null;
            const value = item.value != null ? item.value : item.headline;
            if (!value) return null;
            const label = item.label != null ? item.label : item.subheadline;
            return {
              value: String(value),
              label: label ? String(label) : ''
            };
          }).filter(Boolean)
        : [];
      if (custom.length) return custom.slice(0, 4);

      const list = [];
      if (provider && provider.rating) {
        list.push({ label: 'Average rating', value: provider.rating + '★' });
      } else {
        list.push({ label: 'Average rating', value: 'Top-rated' });
      }
      if (provider && provider.warranty) {
        list.push({ label: 'Warranty', value: provider.warranty });
      }
      list.push({ label: 'Financing', value: financingText || '$0 down options' });
      list.push({ label: 'Response time', value: 'Under 24 hrs' });
      return list.slice(0, 4);
    }

    function buildPromoCard(provider){
      const promos = Array.isArray(provider?.promos) ? provider.promos : [];
      if (!promos.length) return '';
      const copy = resolvePromoCopy(provider);
      const items = promos.map(function(promo, idx){
        return '<div class="bonus-card">'
          +   '<div class="bonus-index">'+ (idx + 1) +'</div>'
          +   '<div><div class="bonus-title">'+ escapeHtml(String(promo)) +'</div></div>'
          + '</div>';
      }).join('');
      const timerSeconds = Number(copy.timer_seconds);
      const timerEnabled = Number.isFinite(timerSeconds) && timerSeconds > 0;
      const timerHtml = timerEnabled
        ? '<div class="promo-timer" data-seconds="'+ timerSeconds +'">'+ (formatCountdown(timerSeconds) || '') +'</div>'
        : '';
      return ''
        + '<article class="match-panel promo-card">'
        +   '<div class="promo-header">'
        +     '<div>'
        +       '<div class="promo-eyebrow">'+ escapeHtml(copy.eyebrow || DEFAULT_PROMO_COPY.eyebrow) +'</div>'
        +       '<h2>'+ escapeHtml(copy.headline || DEFAULT_PROMO_COPY.headline) +'</h2>'
        +       '<p class="promo-note">'+ escapeHtml(copy.note || DEFAULT_PROMO_COPY.note) +'</p>'
        +     '</div>'
        +     timerHtml
        +   '</div>'
        +   '<div class="promo-bonuses">'+ items +'</div>'
        + '</article>';
    }

    function buildCallCard(provider){
      const digits = String((provider && provider.phone) || '').replace(/\D/g, '');
      if (!digits) return '';
      const pretty = prettyPhone(digits);
      const copy = resolveCallCopy(provider);
      const tokens = buildTemplateTokens(provider, {
        phone: digits,
        phone_pretty: pretty
      });
      const headline = copy.headline_template
        ? formatTemplate(copy.headline_template, tokens)
        : formatTemplate(DEFAULT_CALL_COPY.headline_template, tokens);
      const buttonLabel = copy.button_label
        ? formatTemplate(copy.button_label, tokens)
        : formatTemplate(DEFAULT_CALL_COPY.button_label, tokens);
      return ''
        + '<article class="match-panel promo-card call-card" style="gap:18px">'
        +   '<div class="promo-header">'
        +     '<div>'
        +       '<div class="promo-eyebrow">'+ escapeHtml(copy.eyebrow || DEFAULT_CALL_COPY.eyebrow) +'</div>'
        +       '<h2>'+ escapeHtml(headline || ('Call '+ (provider?.company || 'your roofer'))) +'</h2>'
        +       '<p class="promo-note">'+ escapeHtml(copy.note || DEFAULT_CALL_COPY.note) +'</p>'
        +     '</div>'
        +   '</div>'
        +   '<a href="tel:+1'+ digits +'" class="btn" style="display:flex;justify-content:center;background:linear-gradient(135deg,var(--accent),var(--accent-2));color:#04101a;font-weight:800;">'
        +     escapeHtml(buttonLabel || ('Call ' + pretty))
        +   '</a>'
        + '</article>';
    }

    function buildCalendarCard(provider){
      const copy = resolveCalendarCopy(provider);
      return ''
        + '<article class="match-panel scheduler-card">'
        +   '<div class="scheduler-header">'
        +     '<h2>'+ escapeHtml(copy.headline || DEFAULT_CALENDAR_COPY.headline) +'</h2>'
        +     '<p>'+ escapeHtml(copy.subhead || DEFAULT_CALENDAR_COPY.subhead) +'</p>'
        +   '</div>'
        +   '<div id="nativeCalendarMount"></div>'
        + '</article>';
    }

    function initPromoCountdown(root){
      const timer = (root || document).querySelector('.promo-timer[data-seconds]');
      if (!timer || timer._rmCountdownAttached) return;
      let seconds = Number(timer.dataset.seconds) || 420;
      if (!Number.isFinite(seconds) || seconds <= 0) return;
      timer._rmCountdownAttached = true;
      const format = (s) => {
        const m = Math.floor(s / 60);
        const sec = String(s % 60).padStart(2, '0');
        return m + ':' + sec;
      };
      timer.textContent = format(seconds);
      const interval = setInterval(() => {
        seconds -= 1;
        if (seconds <= 0) {
          seconds = 0;
          clearInterval(interval);
        }
        timer.textContent = format(seconds);
      }, 1000);
    }

    function showTY(customCopy){
      const copy = resolveTyCopy(customCopy);
      stage.innerHTML = '<div class="fade-enter fade-enter-active" style="display:grid;gap:16px;padding-bottom:8px">'
        + '<div class="pill">'+ escapeHtml(copy.pill) +'</div>'
        + '<h1>'+ escapeHtml(copy.headline) +'</h1>'
        + '<div class="sub">'+ escapeHtml(copy.subhead) +'</div>'
        + '</div>';
      postHeightAggressively();
    }

    // --- Preconnect helper for faster third-party loads ---
    function ensurePreconnect(url){
      if (document.querySelector('link[rel="preconnect"][href="'+url+'"]')) return;
      var l = document.createElement('link');
      l.rel = 'preconnect';
      l.href = url;
      l.crossOrigin = 'anonymous';
      document.head.appendChild(l);
    }

    // Warm sockets for API calls (only when configured)
    if (RM_CONFIG.supabaseUrl && RM_CONFIG.supabaseUrl.startsWith('http')) {
      ensurePreconnect(RM_CONFIG.supabaseUrl.replace(/\/$/, ''));
    }

    /** === Utilities === */
    function el(tag, cls, txt){ const n=document.createElement(tag); if(cls) n.className=cls; if(arguments.length===3 && txt!=null) n.textContent=txt; return n; }

    /* Auto-fit a single-line element's font-size (mobile only) */
    function fitOneLineMobile(el, opts){
      if (!window.matchMedia || !window.matchMedia('(max-width:560px)').matches) return;
      if (!el) return;
      const maxPx = (opts && opts.maxPx) || 28; // starting size
      const minPx = (opts && opts.minPx) || 16;

      el.style.whiteSpace = 'nowrap';
      el.style.display = 'inline-block';
      el.style.maxWidth = '100%';

      let size = maxPx;
      el.style.fontSize = size + 'px';

      const parentWidth = el.parentElement ? el.parentElement.clientWidth : el.clientWidth;
      while (size > minPx && el.scrollWidth > parentWidth) {
        size -= 1;
        el.style.fontSize = size + 'px';
      }
    }

    function button(label, variant, onClick){ const b=document.createElement("button"); b.type="button"; b.className="btn"+(variant?(" "+variant):""); b.textContent=label; b.addEventListener("click", onClick); return b; }

    function safeFocus(el){
      try{
        if(!el) return;
        // Focus without scrolling; let the browser keep the caret visible
        requestAnimationFrame(function(){
          if (typeof el.focus === "function") el.focus({ preventScroll: true });
        });
      }catch(_){}
    }

    function pinQuestionTop(){
      try{
        const stg = document.getElementById('stage');
        if (!stg) return;

        // Pin the current step’s H1 to ~10px from top of viewport.
        const h = stg.querySelector('h1');
        if (!h) return;

        const targetTop = 10; // px
        const r = h.getBoundingClientRect();

        // Only scroll if the heading sits below the target line.
        if (r.top > targetTop + 4) {
          window.scrollBy({ top: (r.top - targetTop), left: 0, behavior: 'auto' });
        }
      }catch(_){}
    }

    function formatPhone(v){ const d=v.replace(/\D/g,"").slice(0,10); const a=d.slice(0,3), b=d.slice(3,6), c=d.slice(6,10); if(d.length<=3) return a; if(d.length<=6) return '('+a+') '+b; return '('+a+') '+b+'-'+c; }
    function normalizePhone(v){ return (v||"").replace(/\D/g,""); }

    /* Format a plain number (10 or 11 digits) into (XXX) XXX-XXXX for display */
    function prettyPhone(num){
      const d = num.replace(/\D/g, "");
      const n = d.length === 11 && d.startsWith("1") ? d.slice(1) : d;
      if (n.length !== 10) return num; // fallback
      return "(" + n.slice(0,3) + ") " + n.slice(3,6) + "-" + n.slice(6);
    }

    // Enhanced phone validation: NANP rules + reject N11 and 555 area codes
    function isValidUSPhone(v){
      const d=normalizePhone(v);
      if(d.length!==10) return false;
      const area=d.slice(0,3), exch=d.slice(3,6);
      if(!/^[2-9]\d{2}$/.test(area)) return false;         // area: 200–999, no 0/1 start
      if(!/^[2-9]\d{2}$/.test(exch)) return false;         // exchange: 200–999
      if(/^[2-9]11$/.test(area)) return false;             // N11 codes (211,311,...,911)
      if(area === "555") return false;                     // disallow 555 area
      const bad=new Set(["0000000000","1111111111","2222222222","3333333333","4444444444","5555555555","6666666666","7777777777","8888888888","9999999999","1234567890","0123456789"]);
      return !bad.has(d);
    }

    function isValidEmail(e){ return /^[^\s@]+@[^\s@]{1,}\.[^\s@]{2,}$/.test(e); }
    function isDisposableDomain(e){ const d=(e||"").toLowerCase().split("@")[1]||""; return ["yopmail.com","mailinator.com","guerrillamail.com","10minutemail.com","tempmail.com","tempmailo.com","trashmail.com","moakt.com","getnada.com","sharklasers.com","maildrop.cc","dispostable.com","burnermail.io","fakeinbox.com","temp-mail.org","mintemail.com","inboxbear.com","mailcatch.com","throwawaymail.com","getairmail.com"].includes(d); }
    function highlightCompanyInSubhead(text, company){ if(!company) return text; const esc=company.replace(/[.*+?^${}()|[\]\\]/g,"\\$&"); const re=new RegExp(esc,"i"); return text.replace(re, function(m){ return '<span class="hl-badge">'+m+'</span>'; }); }
    function escapeHtml(str){ return String(str||"").replace(/[&<>"']/g, function(s){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[s]); }); }
    function escapeAttr(str){ return String(str||"").replace(/[&"'<>]/g, function(ch){ return ({'&':'&amp;','"':'&quot;',"'":'&#39;','<':'&lt;','>':'&gt;'}[ch]); }); }
    function hidden(id,val){ const i=document.createElement('input'); i.type='hidden'; i.id=id; i.name=id; i.value=val||""; return i; }
    function displayCityState(){
      const c = state.cityGuess || "";
      const s = state.stateGuess || "";
      const zipSource =
        (state.answers && state.answers.address && state.answers.address.zip) ||
        (state.answers && state.answers.zip) ||
        "";
      const zip = String(zipSource || '').replace(/\D/g, '').slice(0, 5);
      if (c && s) return c + ', ' + s;
      if (c) return c;
      if (s) return s;
      if (zip) return 'ZIP ' + zip;
      return 'your area';
    }
    function updateAreaLabel(){
      const label = document.getElementById('areaLabel');
      if (label) label.textContent = displayCityState();
    }

    function capitalize(str){
      str = String(str || '');
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    }

    function formatLabel(t){
      const txt = String(t || '');
      const city = displayCityState();
      const first = (state && state.answers && state.answers.name_first)
        ? String(state.answers.name_first).trim()
        : '';
      const name = first ? capitalize(first) : 'Friend'; // fallback if missing
      return txt
        .replace(/\{CITY\}/g, city)
        .replace(/\{name_first\}/gi, name)  // preferred token
        .replace(/\{Name\}/g, name);        // backward-compat token
    }

    /* === TCPA helpers start === */

    function readComplianceFields(){
      // primary: our persistent hidden input (outside the dynamic stage)
      var tfInput = document.getElementById('xxTrustedFormCertUrl');
      var tf = tfInput && tfInput.value ? tfInput.value : '';

      // fallback: if the SDK inserted a field elsewhere by name
      if (!tf) {
        var any = document.querySelector('input[name="xxTrustedFormCertUrl"]');
        if (any && any.value) tf = any.value;
      }

      var tcpaEl = document.getElementById('tcpa_text') || document.querySelector('[data-tf-element-role="consent-language"]');
      var tcpa = tcpaEl ? tcpaEl.innerText : (state && state.tcpa_text) || '';
      return { tf, tcpa };   // no LeadiD
    }

    function waitForComplianceValues(timeoutMs){
      return new Promise((resolve)=>{
        const t0 = Date.now();
        (function poll(){
          const { tf } = readComplianceFields();   // only tf matters
          if (tf) return resolve(true);
          if (Date.now() - t0 > (timeoutMs||8000)) return resolve(false);
          setTimeout(poll, 120);
        })();
      });
    }

    /* === TCPA helpers end === */

    function measureDoc(){ var b=document.body,d=document.documentElement; return Math.max(b.scrollHeight,d.scrollHeight,b.offsetHeight,d.offsetHeight,b.clientHeight,d.clientHeight); }
    function postHeightSoon(){
      const h = measureDoc();
      postToParent({type:'RM_IFRAME_HEIGHT',height:h});
      setTimeout(function(){ postToParent({type:'RM_IFRAME_HEIGHT',height:measureDoc()}); },120);
      setTimeout(function(){ postToParent({type:'RM_IFRAME_HEIGHT',height:measureDoc()}); },400);
    }
    window.addEventListener('message', function(e){
      if (!e || !e.data || e.origin !== PARENT_ORIGIN) return;
      if (e.data.type === 'RM_PING') postHeightSoon();
    });

    // Repeatedly ping height so the parent shrinks quickly after booking
    function nudgeHeightFor(ms){
      const stop = Date.now() + (ms||4000);
      (function tick(){
        postHeightSoon();
        if (Date.now() < stop) setTimeout(tick, 200);
      })();
    }

    document.addEventListener('visibilitychange', function(){
      if (!document.hidden) postHeightAggressively();
    });

    // Keep early page super light; only go aggressive when we actually need it
    function postHeightAggressively(mode){
      // default: light
      var times = mode === 'aggressive'
        ? [0, 120, 300, 600, 1200, 1800]
        : [0, 200];

      times.forEach(function(t){ setTimeout(postHeightSoon, t); });
    }
    
    // Defer costly observers until the browser is idle (keeps first paint snappy)
    (function(){
      var ric = window.requestIdleCallback || function(cb){ return setTimeout(cb, 500); };
      ric(function(){
        try {
          new ResizeObserver(postHeightSoon).observe(document.body);
        } catch(_) {}
        window.addEventListener('resize', postHeightSoon, { passive:true });
        window.addEventListener('orientationchange', postHeightSoon);
      });
    })();

    let ZIP_DB = null;
    let ZIP_DB_PROMISE = null;

    function preloadZipCityMap(){
      if (ZIP_DB || ZIP_DB_PROMISE) return;
      ZIP_DB_PROMISE = fetch('/zip_city_map.json', { cache: 'force-cache' })
        .then((res) => {
          if (!res.ok) throw new Error('zip map fetch failed: ' + res.status);
          return res.json();
        })
        .then((data) => {
          if (data && typeof data === 'object') {
            ZIP_DB = data;
          }
          return ZIP_DB;
        })
        .catch((err) => {
          console.warn('[RoofMetric] zip map load failed:', err?.message || err);
          ZIP_DB_PROMISE = null;
          return null;
        });
    }

    async function ensureZipCityMapLoaded(){
      if (ZIP_DB) return ZIP_DB;
      if (!ZIP_DB_PROMISE) preloadZipCityMap();
      try {
        return await ZIP_DB_PROMISE;
      } catch (_) {
        return null;
      }
    }

    function lookupZipLocal(zip){
      if (!ZIP_DB) return null;
      const entry = ZIP_DB[zip];
      if (!entry) return null;
      if (typeof entry === 'string') {
        return { city: entry, state: '' };
      }
      if (entry && typeof entry === 'object') {
        return {
          city: typeof entry.city === 'string' ? entry.city : '',
          state: typeof entry.state === 'string' ? entry.state : ''
        };
      }
      return null;
    }

    const TF_FIELD_NAME = 'xxTrustedFormCertUrl';
    let _tfShouldLoad = false;
    let _tfScriptLoading = false;
    let _tfScriptLoaded = false;
    let _tfLoadAttempts = 0;

    function lazyLoadCompliance(force){
      if (force) _tfShouldLoad = true;
      if (_tfScriptLoaded || _tfScriptLoading) return;
      _tfShouldLoad = true;
      waitForTrustedFormPrereqs();
    }
    window.__RM_LAZY_TF__ = lazyLoadCompliance;

    function scheduleTrustedFormLoad() {
      if (window.__RM_LAZY_TF__) {
        window.__RM_LAZY_TF__(true);
      } else {
        window.__RM_TF_BOOT__ = true;
      }
    }

    if (document.readyState === 'complete') {
      scheduleTrustedFormLoad();
    } else {
      window.addEventListener('load', scheduleTrustedFormLoad, { once: true });
    }

    if (window.__RM_TF_BOOT__) {
      lazyLoadCompliance(true);
      window.__RM_TF_BOOT__ = false;
    }

    function waitForTrustedFormPrereqs(){
      if (!_tfShouldLoad || _tfScriptLoaded || _tfScriptLoading) return;
      if (!document.getElementById(TF_FIELD_NAME)) {
        setTimeout(waitForTrustedFormPrereqs, 120);
        return;
      }
      if (!document.querySelector('[data-tf-element-role="consent-language"]')) {
        const obs = new MutationObserver(() => {
          if (document.querySelector('[data-tf-element-role="consent-language"]')) {
            obs.disconnect();
            waitForTrustedFormPrereqs();
          }
        });
        obs.observe(document.body, { childList:true, subtree:true });
        return;
      }
      injectTrustedFormScript();
    }

    function injectTrustedFormScript(){
      if (_tfScriptLoaded || _tfScriptLoading) return;
      _tfScriptLoading = true;
      const tf = document.createElement('script');
      tf.type = 'text/javascript';
      tf.async = true;
      tf.src =
        (location.protocol === 'https:' ? 'https' : 'http') +
        '://api.trustedform.com/trustedform.js' +
        '?field=' + encodeURIComponent(TF_FIELD_NAME) +
        '&use_tagged_consent=true' +
        '&l=' + (Date.now() + Math.random());
      tf.onload = function(){
        _tfScriptLoaded = true;
        _tfScriptLoading = false;
        _tfLoadAttempts = 0;
        setTimeout(function(){
          const val = document.getElementById(TF_FIELD_NAME)?.value;
          if (!val) console.warn('TrustedForm script loaded but cert value empty (will retry read before submit).');
        }, 200);
      };
      tf.onerror = function(){
        _tfScriptLoading = false;
        _tfScriptLoaded = false;
        _tfLoadAttempts++;
        if (_tfLoadAttempts < 3) {
          console.warn('TrustedForm failed to load, retrying… attempt ' + (_tfLoadAttempts + 1));
          setTimeout(waitForTrustedFormPrereqs, 800 * _tfLoadAttempts);
        } else {
          console.warn('TrustedForm failed after retries; certificate may be missing.');
        }
      };
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(tf, firstScript);
    }

    const GOOGLE_PLACES_API_KEY = "AIzaSyA_YoQdQkoJBj_HRnrNEX43cvvoVxVkCVw";
    let _placesLoading = false, _placesReady = false;
    const _zipMetaCache = new Map();
    function lazyLoadPlaces(){
      return new Promise(function(res){
          // Preconnect early to Google Maps domains (warms sockets instantly)
          ensurePreconnect('https://maps.googleapis.com');
          ensurePreconnect('https://maps.gstatic.com');

        if (_placesReady) return res(true);
        if (_placesLoading){ let t=0;(function poll(){ if(_placesReady) return res(true); if(++t>80) return res(false); setTimeout(poll,75); })(); return; }
        _placesLoading = true;
        const s = document.createElement('script');
        s.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(GOOGLE_PLACES_API_KEY) + "&libraries=places&v=weekly&loading=async";
        s.async = true; s.defer = true;
        s.onload = function(){ _placesReady = true; res(true); };
        s.onerror = function(){ res(false); };
        document.body.appendChild(s);
      });
    }

    /** ================================
     *  Autocomplete (new-first, legacy-fallback) + Geocoder fallback
     *  ================================ */
    function ensureSessionToken(reset) {
      if (!window.__rmSession || reset === true) {
        window.__rmSession = { object: null, value: 'rm-' + Math.random().toString(36).slice(2) + Date.now().toString(36) };
        try {
          if (google?.maps?.places?.AutocompleteSessionToken) {
            const obj = new google.maps.places.AutocompleteSessionToken();
            window.__rmSession.object = obj;
            const s = (typeof obj.toString === 'function') ? String(obj.toString()) : '';
            if (s && s !== '[object Object]') window.__rmSession.value = s;
          }
        } catch(_) {}
      }
      return window.__rmSession;
    }

    function normalizeSuggestionPrediction(s) {
      const pp = s?.placePrediction || s?.prediction || s;
      const main = pp?.mainText?.text || pp?.structuredFormat?.mainText?.text || '';
      const secondary = pp?.secondaryText?.text || pp?.structuredFormat?.secondaryText?.text || '';
      const description = pp?.text?.text || [main, secondary].filter(Boolean).join(', ');
      return {
        placeId: pp?.placeId || null,
        mainText: main || description.split(',')[0],
        secondaryText: secondary,
        description,
        raw: s
      };
    }

    function normalizeLegacyPrediction(p) {
      const main = p?.structured_formatting?.main_text || '';
      const secondary = p?.structured_formatting?.secondary_text || '';
      return {
        placeId: p?.place_id || null,
        mainText: main || (p?.description?.split(',')[0] || ''),
        secondaryText: secondary,
        description: p?.description || [main, secondary].filter(Boolean).join(', '),
        raw: p
      };
    }

    function boundsToBias(bounds){
      if (!bounds || typeof bounds.getNorthEast !== 'function' || typeof bounds.getSouthWest !== 'function') return null;
      const ne = bounds.getNorthEast(), sw = bounds.getSouthWest();
      return { north: ne.lat(), south: sw.lat(), east: ne.lng(), west: sw.lng() };
    }

    function rectFromBounds(bounds){
      if (!bounds || typeof bounds.getNorthEast !== 'function' || typeof bounds.getSouthWest !== 'function') return null;
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      return {
        southWest: { latitude: sw.lat(), longitude: sw.lng() },
        northEast: { latitude: ne.lat(), longitude: ne.lng() }
      };
    }

    function rectFromBiasLiteral(bias){
      if (!bias) return null;
      const north = Number(bias.north);
      const south = Number(bias.south);
      const east = Number(bias.east);
      const west = Number(bias.west);
      if (![north, south, east, west].every((v) => Number.isFinite(v))) return null;
      return {
        southWest: { latitude: Math.min(north, south), longitude: Math.min(east, west) },
        northEast: { latitude: Math.max(north, south), longitude: Math.max(east, west) }
      };
    }

    async function fetchAutocompletePredictions(opts) {
      const {
        input,
        sessionToken,
        bounds,
        bias,
        primaryTypes = ['street_address', 'premise', 'subpremise', 'route'],
        regionCode = 'US'
      } = opts || {};

      if (!input || !google?.maps?.places) return { predictions: [], status: 'ZERO_RESULTS' };

      const hasNew = !!(google.maps.places.AutocompleteSuggestion &&
        typeof google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions === 'function');
      if (hasNew) {
        const filteredPrimaryTypes = (primaryTypes || [])
          .map((type) => (typeof type === 'string' ? type.trim() : ''))
          .filter((type) => type && type.toLowerCase() !== 'address');
        const req = {
          input: String(input),
          includedRegionCodes: [regionCode],
          sessionToken: sessionToken?.object || sessionToken?.value || undefined
        };
        if (filteredPrimaryTypes.length) {
          req.includedPrimaryTypes = filteredPrimaryTypes;
        }
        const rect = bounds ? rectFromBounds(bounds) : null;
        if (rect) {
          req.locationRestriction = rect;
        } else if (bias) {
          const biasRect = rectFromBiasLiteral(bias);
          if (biasRect) req.locationBias = { rectangle: biasRect };
        }

        try {
          const { suggestions = [] } =
            await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(req);
          return {
            predictions: suggestions.map(normalizeSuggestionPrediction),
            status: suggestions.length ? 'OK' : 'ZERO_RESULTS',
            mode: 'new'
          };
        } catch (err) {
          console.warn('[RoofMetric] new AutocompleteSuggestion failed; falling back:', err);
        }
      }

      if (google?.maps?.places?.AutocompleteService) {
        const svc = new google.maps.places.AutocompleteService();
        const legacyReq = {
          input: String(input),
          types: ['address'],
          componentRestrictions: { country: regionCode.toLowerCase() },
          sessionToken: sessionToken?.object || sessionToken?.value || undefined
        };
        if (bounds) legacyReq.bounds = bounds;
        if (bias && !legacyReq.bounds) legacyReq.locationBias = bias;

        const { predictions, status } = await new Promise((resolve) => {
          svc.getPlacePredictions(legacyReq, (preds, st) =>
            resolve({ predictions: Array.isArray(preds) ? preds : [], status: st || 'UNKNOWN' })
          );
        });
        return {
          predictions: predictions.map(normalizeLegacyPrediction),
          status,
          mode: 'legacy'
        };
      }

      return { predictions: [], status: 'UNAVAILABLE', mode: 'none' };
    }

    async function fetchPlaceDetailsFromSuggestion(item) {
      try {
        const pp = item?.raw?.placePrediction;
        if (pp && typeof pp.toPlace === 'function') {
          const place = pp.toPlace();
          await place.fetchFields({ fields: ['addressComponents', 'formattedAddress', 'location'] });
          const address_components = (place.addressComponents || []).map(c => ({
            long_name: c.longText || c.long_name || '',
            short_name: c.shortText || c.short_name || '',
            types: Array.isArray(c.types) ? c.types.slice() : []
          }));
          const geometry = place.location ? { location: place.location } : null;
          return { address_components, formatted_address: place.formattedAddress || '', geometry };
        }
      } catch (err) {
        console.warn('[RoofMetric] Place.fetchFields fallback to geocoder:', err);
      }

      if (item?.placeId && google?.maps?.Geocoder) {
        const geocoder = new google.maps.Geocoder();
        return await new Promise((resolve) => {
          geocoder.geocode({ placeId: item.placeId }, (results, status) => {
            if (status === 'OK' && Array.isArray(results) && results.length) {
              resolve({
                address_components: results[0].address_components || [],
                formatted_address: results[0].formatted_address || '',
                geometry: results[0].geometry || null
              });
            } else {
              resolve(null);
            }
          });
        });
      }
      return null;
    }
    
    async function getZipMetadata(zip){
      const normalized = String(zip || '').replace(/\D/g,'').slice(0,5);
      if (!/^\d{5}$/.test(normalized)) return null;
      const cached = _zipMetaCache.get(normalized);
      if (cached) {
        if (typeof cached.then === 'function') return cached;
        return cached;
      }

      await ensureZipCityMapLoaded();
      const inline = lookupZipLocal(normalized);
      if (inline && inline.city) {
        const inlineMeta = {
          city: inline.city || '',
          state: inline.state || '',
          bounds: null,
          location: null
        };
        _zipMetaCache.set(normalized, inlineMeta);
        fetchZipMetaFromGoogle(normalized)
          .then((enriched) => {
            if (enriched && (enriched.city || enriched.state || enriched.bounds)) {
              _zipMetaCache.set(normalized, enriched);
            }
          })
          .catch(()=>{});
        return inlineMeta;
      }

      const pending = (async () => {
        const meta = await fetchZipMetaFromGoogle(normalized);
        return meta || { city: '', state: '', bounds: null, location: null };
      })();

      _zipMetaCache.set(normalized, pending);
      const resolved = await pending;
      _zipMetaCache.set(normalized, resolved);
      return resolved;
    }

    async function fetchZipMetaFromGoogle(normalized){
      if (!_placesReady) {
        const ok = await lazyLoadPlaces();
        if (!ok) return null;
      }
      if (!window.google || !google.maps) return null;

      const geocoder = new google.maps.Geocoder();
      const fetchByRequest = (request) =>
        new Promise((resolve) => {
          geocoder.geocode(request, function(results, status){
            if (status === "OK" && Array.isArray(results) && results.length) {
              resolve(results[0]);
            } else {
              resolve(null);
            }
          });
        });

      const primary = await fetchByRequest({
        address: normalized,
        componentRestrictions: { country: "US", postalCode: normalized }
      });
      if (!primary) return null;

      const comp = parseAddressComponents(primary.address_components || []);
      const cityCandidate =
        comp.locality ||
        comp.postal_town ||
        comp.sublocality ||
        comp.sublocality_level_1 ||
        comp.administrative_area_level_3 ||
        comp.administrative_area_level_2 ||
        comp.neighborhood ||
        "";
      let stateCandidate =
        comp.administrative_area_level_1 ||
        comp.administrative_area_level_1_long ||
        "";

      const meta = {
        city: cityCandidate,
        state: stateCandidate,
        bounds: (primary.geometry && (primary.geometry.viewport || primary.geometry.bounds)) || null,
        location: (primary.geometry && primary.geometry.location) || null
      };

      if ((!meta.city || !meta.state) && meta.location) {
        const reverse = await fetchByRequest({ location: meta.location });
        if (reverse) {
          const revComp = parseAddressComponents(reverse.address_components || []);
          if (!meta.city) {
            meta.city =
              revComp.locality ||
              revComp.postal_town ||
              revComp.sublocality ||
              revComp.sublocality_level_1 ||
              revComp.administrative_area_level_3 ||
              revComp.administrative_area_level_2 ||
              revComp.neighborhood ||
              meta.city;
          }
          if (!meta.state) {
            meta.state =
              revComp.administrative_area_level_1 ||
              revComp.administrative_area_level_1_long ||
              meta.state;
          }
        }
      }

      if (!meta.city && typeof primary.formatted_address === 'string') {
        meta.city = primary.formatted_address.split(',')[0].trim();
      }

      if (!meta.city || !meta.state) {
        try {
          const regionResult = await fetchAutocompletePredictions({
            input: normalized + ' United States',
            primaryTypes: ['postal_code', 'locality', 'administrative_area_level_2'],
            types: ['(regions)']
          });
          const regionList = Array.isArray(regionResult?.predictions) ? regionResult.predictions : [];
          if (regionList.length) {
            const lowerZip = normalized.toLowerCase();
            const region =
              regionList.find((item) => (item.description || '').toLowerCase().includes(lowerZip)) || regionList[0];
            if (region) {
              const terms = Array.isArray(region.raw?.terms) ? region.raw.terms.map((t) => t.value) : [];
              if (!meta.city && terms.length) meta.city = terms[0];
              if (!meta.state && terms.length > 1) meta.state = terms[1];
              if ((!meta.city || !meta.state) && typeof region.description === 'string') {
                const parts = region.description.split(',').map((s) => s.trim()).filter(Boolean);
                if (!meta.city && parts.length) meta.city = parts[0];
                if (!meta.state && parts.length > 1) {
                  const piece = parts[1].split(/\s+/).filter(Boolean)[0];
                  if (piece) meta.state = piece;
                }
              }
            }
          }
        } catch(err){
          console.warn('[RoofMetric] ZIP autocomplete fallback failed:', err);
        }
      }

      if (!meta.city) meta.city = '';
      if (!meta.state) meta.state = '';

      return meta;
    }

    function parseAddressComponents(components){
      const out={};
      for(var i=0;i<(components||[]).length;i++){
        const c = components[i];
        const t=c.types||[];
        if(t.indexOf("street_number")>-1) out.street_number=c.long_name;
        if(t.indexOf("route")>-1) out.route=c.long_name;
        if(t.indexOf("locality")>-1) out.locality=c.long_name;
        if(t.indexOf("postal_town")>-1) out.postal_town=c.long_name;
        if(t.indexOf("neighborhood")>-1) out.neighborhood=c.long_name;
        if(t.indexOf("sublocality")>-1) out.sublocality=c.long_name;
        if(t.indexOf("sublocality_level_1")>-1) out.sublocality_level_1=c.long_name;
        if(t.indexOf("administrative_area_level_3")>-1) out.administrative_area_level_3=c.long_name;
        if(t.indexOf("administrative_area_level_2")>-1) out.administrative_area_level_2=c.long_name;
        if(t.indexOf("administrative_area_level_1")>-1){
          out.administrative_area_level_1=c.short_name;
          out.administrative_area_level_1_long=c.long_name;
        }
        if(t.indexOf("postal_code")>-1) out.postal_code=c.long_name;
      }
      return out;
    }

    async function bootFirstStep(){
      try{
        showLoadingSkeleton();
        const payloadLog = {
          session_id: rmSessionId(),
          project_id: RM_CONFIG.projectId || null,
          project_slug: RM_CONFIG.projectSlug || 'roof-quiz'
        };
        console.log('[RoofMetric] quiz init payload', payloadLog);
        await BOOTSTRAP_PROMISE;
        await ensureQuestionsReady();
        if (!Array.isArray(QUESTIONS) || !QUESTIONS.length) {
          hideLoadingSkeleton();
          showFatal('Unable to load quiz');
          return;
        }

        if (!state.project_id && RM_CONFIG.projectId) {
          state.project_id = RM_CONFIG.projectId;
        }

        const entryMeta = RM_CONFIG?.quizEntry && RM_CONFIG.quizEntry.question_id
          ? RM_CONFIG.quizEntry
          : {
              question_id: QUESTIONS[0].question_id || QUESTIONS[0].id,
              position: typeof QUESTIONS[0].source_position === 'number' ? QUESTIONS[0].source_position : 0
            };
        state.current_question_id = entryMeta?.question_id || QUESTIONS[0].question_id || QUESTIONS[0].id;
        state.current_position = typeof entryMeta?.position === 'number' ? entryMeta.position : 0;

        const resolvedLog = {
          project_id: state.project_id || RM_CONFIG.projectId || null,
          variant_id: state.variant_id || window.__RM_VARIANT_ID__ || null,
          first_question_id: state.current_question_id || null,
          position: state.current_position
        };
        console.log('[RoofMetric] quiz init resolved', resolvedLog);

        hideLoadingSkeleton();
        state._stepStartMs = Date.now();
        postEvent('step_view');
        render();
      }catch(e){
        hideLoadingSkeleton();
        console.error('boot error', e);
        showFatal('Unable to load quiz');
      }
    }

    document.addEventListener('focusin', function(){
      setTimeout(pinQuestionTop, 60);
    }, { passive:true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function(){
        setTimeout(pinQuestionTop, 60);
      });
    }

    // Abandon tracking (fires when user leaves the quiz)
    let _abandonSent = false;
    window.addEventListener('beforeunload', function () {
      if (_abandonSent) return;
      _abandonSent = true;
      if (typeof postEvent === 'function') {
        postEvent('abandon', {
          last_step: state.step,
          last_step_id: (QUESTIONS[state.step] || {}).id || '',
          step_elapsed_ms: Date.now() - (state._stepStartMs || state.startedAt)  
        });
      }
    });

    // boot — ensure DOM is ready before first render
    document.addEventListener("DOMContentLoaded", function () {
      try {
        bootFirstStep();
        // Pre-warm TrustedForm script so consent is ready by the contact step
        lazyLoadCompliance();
        trackTrustedFormValue();

        // Defer global key handlers until the user touches/presses a key once
        var keyHandlerBound = false;
        function bindKeysOnce() {
          if (keyHandlerBound) return;
          keyHandlerBound = true;
          document.addEventListener("keydown", function(e){
            if(e.key==="ArrowLeft") onBack();
            if(e.key==="ArrowRight") onNext();
          }, { passive:true });
          document.removeEventListener('pointerdown', bindKeysOnce);
          document.removeEventListener('keydown', bindKeysOnce);
        }
        document.addEventListener('pointerdown', bindKeysOnce, { once:true });
        document.addEventListener('keydown',      bindKeysOnce, { once:true });
      } catch (e) {
        showFatal(e.message || e);
      }
    });
